<div class="f-14 transaction-main" id="transaction-list-dropdown">
    <div class="row">
      <div class="col-lg-12" >
        <app-transaction-summary-shared
          [summary]="summary$"
          [transactions]="transactions$"
          [transactionType]="1"
          *ngIf="!isSuperAdmin"
        ></app-transaction-summary-shared>
        <div class="eatos-card">
          <div class="">
            <!-- <div class="card-body"> -->
            <div class="d-sm-flex justify-content-between sales-main">
              <div class="d-flex gap-4">
                <div class="d-flex flex-wrap sales-data w-sm-auto w-100">
                  <div class="col-auto col-report">
                    <div class="input-group cusdaterangepicker w-auto">
                      <div
                        class="net-sale-daterange-picker form-group text-start form-control border-0 p-0"
                        style="border-radius: 2.6px"
                      >
                        <div
                          class="datepickerwrap form-control"
                          daterangepicker
                          [options]="options"
                          (selected)="selectedDate($event)"
                          style="border-radius: 2.6px;"
                          (click)="setDateTexts()"
                        >
                          <span class="date-text">
                            <span class="display-date f-12">{{
                              startDateDisplayFormatted | translate | async
                            }}</span>
                            -
                            <span class="display-date f-12">{{
                              endDateDisplayFormatted | translate | async
                            }}</span>
                          </span>
                          <img
                            src="../../../../assets/images/dashboard-images/bx-calendar.svg"
                            class="picker-icon"
                            class="ms-2"
                          />
                        </div>
                      </div>
                      <div class="filter-btn" (click)="OpenFilterCanva(content1)">
                        <button>
                          <img src="/assets/images/filter.svg" alt="filter" />
                        </button>
                      </div>
                      <div class="">
                        <ng-template #content1 let-offcanvas>
                          <div class="Filter-Canvas-open">
                            <!-- filter -->
                            <div
                              class="action-data"
                              *ngIf="OpenDetails === 'mainMenu'"
                            >
                              <h2 class="mb-0">{{ "Filters" | translate | async }}</h2>
                              <button
                                type="button"
                                class="btn-close"
                                aria-label="Close"
                                (click)="offcanvas.dismiss('Cross click')"
                              ></button>
                            </div>
                            <!-- End Filter -->
                            <div
                              class="back-time"
                              *ngIf="OpenDetails === 'StartEndDate'"
                              (click)="OpenDetails = 'mainMenu'"
                            >
                              <i class="fa-solid fa-arrow-left f-20"></i>
                              <p class="f-14 fw-600 mb-0" *ngIf="Ruler">
                                {{ "Day Part" | translate | async }}
                              </p>
                              <p class="f-14 fw-600 mb-0" *ngIf="!Ruler">
                                {{ startTimeFormatted | translate | async }} - {{ endTimeFormatted | translate | async }}
                              </p>
                            </div>
                            <!-- select payment -->
                            <div
                              class="back-time"
                              *ngIf="OpenDetails === 'SelectPaymentmethod'"
                              (click)="OpenDetails = 'mainMenu'"
                            >
                              <i class="fa-solid fa-arrow-left f-20"></i>
                              <p class="f-14 fw-600 mb-0">{{ "Payment Methods" | translate | async }}</p>
                            </div>
                            <!-- End payment -->
                            <!-- select Employee -->
                            <div
                              class="back-time"
                              *ngIf="OpenDetails === 'SelectEmployee'"
                              (click)="OpenDetails = 'mainMenu'"
                            >
                              <i class="fa-solid fa-arrow-left f-20"></i>
                              <p class="f-14 fw-600 mb-0">{{ "Employees" | translate | async }}</p>
                            </div>
                            <!-- End Employee -->
                            <!-- select paymentStauts -->
                            <div
                              class="back-time"
                              *ngIf="OpenDetails === 'paymentStatus'"
                              (click)="OpenDetails = 'mainMenu'"
                            >
                              <i class="fa-solid fa-arrow-left f-20"></i>
                              <p class="f-14 fw-600 mb-0">{{ "Payment Status" | translate | async }}</p>
                            </div>
                            <!-- End paymentstatus -->
                            <div
                              class="back-time"
                              *ngIf="OpenDetails === 'cardtype'"
                              (click)="OpenDetails = 'mainMenu'"
                            >
                              <i class="fa-solid fa-arrow-left f-20"></i>
                              <p class="f-14 fw-600 mb-0">{{ "Card Type" | translate | async }}</p>
                            </div>
                            <div
                              class="back-time"
                              *ngIf="OpenDetails === 'SelectCard'"
                              (click)="OpenDetails = 'mainMenu'"
                            >
                              <i class="fa-solid fa-arrow-left f-20"></i>
                              <p class="f-14 fw-600 mb-0">{{ "Card" | translate | async }}</p>
                            </div>
                            <div
                              class="back-time"
                              *ngIf="OpenDetails === 'ExportDetails'"
                              (click)="OpenDetails = 'mainMenu'"
                            >
                              <i class="fa-solid fa-arrow-left f-20"></i>
                              <p class="f-14 fw-600 mb-0">{{ "Export" | translate | async }}</p>
                            </div>
                            <div class="action-list">
                              <div class="d-inline-block in-bott">
                                <button
                                  (click)="OpenDetails = 'StartEndDate'"
                                  type="button"
                                  class="btn f-14 fw-500 sec-btn mb-14"
                                  id="dropdownBasic1"
                                  *ngIf="OpenDetails === 'mainMenu'"
                                >
                                  <span *ngIf="Ruler"> {{ "Day Part" | translate | async }} </span>
                                  <span *ngIf="!Ruler ">
                                    {{ startTimeFormatted | translate | async }} - {{ endTimeFormatted | translate | async }}
                                  </span>
                                  <i class="fa-solid fa-chevron-right"></i>
                                </button>
                              </div>
                              <div class="" *ngIf="OpenDetails === 'StartEndDate'">
                                <div class="mb-2 d-flex justify-content-between align-items-center f-12 fw-500 ">
                                  <div class="">
                                    <p class="mb-0">{{ "Start" | translate | async }}</p>
                                  </div>
                                  <div class="start-Date-new position-relative"  >
                                    <!-- (click)="startDateErr = !startDateErr" -->
                                    <ng-select
                                      class="form-select f-12 fw-500"
                                      id="Select1"
                                      [(ngModel)]="startTime"
                                      style="width: 100px !important;"
                                      >
                                      <!-- (blur)="startDateErr = false" -->
                                      <ng-option
                                        [value]="startDate.id"
                                        *ngFor="let startDate of dateTimeArray"
                                      >
                                        {{ startDate.text }}
                                      </ng-option>
                                    </ng-select>
                                   </div>
                                </div>
                                <div class="mb-2 d-flex justify-content-between align-items-center f-12 fw-500" >
                                  <div class="">
                                    <p class="mb-0">End</p>
                                  </div>
                                  <div class="End-Date-new position-relative">
                                    <ng-select
                                      id="Select2"
                                      [(ngModel)]="endTime"
                                      class="form-select f-12 fw-500"
                                  style="width: 100px !important;"
                                    >
                                      <ng-option
                                        [value]="endDate.id"
                                        *ngFor="let endDate of dateTimeArray"
                                      >
                                        {{ endDate.text }}
                                      </ng-option>
                                    </ng-select>
                                  </div>
                                </div>
                                <div class="d-flex justify-content-between f-12 fw-500">
                                  <div class="mt-1">
                                    <input
                                      class="form-check-input custom-form-radio me-2"
                                      type="radio"
                                      id="Second1"
                                      value="Same Day"
                                      [(ngModel)]="ClosingDay"
                                      [checked]="sameDayIsChecked()"
                                      (ngModelChange)="selectClosingDay($event)"
                                    />
                                    <label class="form-check-label" for="Second1">
                                      {{ "Same Day" | translate | async }}
                                    </label>
                                  </div>
                                </div>
                                <div class="d-flex justify-content-between f-12 fw-500">
                                  <div class="mt-1">
                                    <input
                                      class="form-check-input custom-form-radio me-2"
                                      type="radio"
                                      id="Second2"
                                      value="Next Day"
                                      [(ngModel)]="ClosingDay"
                                      [checked]="nextDayIsChecked()"
                                      (ngModelChange)="selectClosingDay($event)"
                                    />
                                    <label class="form-check-label" for="Second2">
                                      {{ "Next Day" | translate | async }}
                                      <i
                                        class="f-10 fas fa-info-circle vertical-align-super"
                                        [ngbPopover]="'Generate your reports for same day or next day (allowing custom 24 hour range) based on the restaurants daily hours of operation' | translate | async"
                                        triggers="mouseenter:mouseleave"
                                        [popoverTitle]="'Next Day' | translate | async"
                                        data-bs-placement="right"
                                      ></i>
                                    </label>
                                  </div>
                                </div>
                                <div class="f-12 fw-500">
                                  <div class="mt-2">
                                    <button
                                      class="btn btn-dark btn-block w-100 pt-1 pb-1 f-14"
                                      (click)="timeFilter(); myDrop.close()"
                                      [disabled]="
                                        (ClosingDay == 'Next Day' &&
                                          startDateDisplay == endDateDisplay) ||
                                        (ClosingDay == 'Same Day' &&
                                          timeDiasbleValidation())
                                      "
                                    >
                                      {{ "Apply" | translate | async }}
                                    </button>
                                  </div>
                                </div> <!-- <div>
                                  <div
                                    class="form-check"
                                    (click)="clickDayAllOption()"
                                  >
                                    <input
                                      class="form-check-input"
                                      checked
                                      type="radio"
                                      name="daygroup"
                                      id="allday"
                                    />
                                    <label class="form-check-label" for="allday">
                                      All Day
                                    </label>
                                  </div>
                                  <div class="dropdown-divider"></div>
                                  <div
                                    class="form-check mb-2"
                                    (click)="clickCustomizeOption()"
                                  >
                                    <input
                                      class="form-check-input"
                                      type="radio"
                                      name="daygroup"
                                      id="custom"
                                    />
                                    <label class="form-check-label" for="custom">
                                      Custom
                                    </label>
                                  </div>
                                  <div
                                    class="form-group d-flex align-items-center start-time"
                                  >
                                    <label class="text-end">Start</label>
                                    <select
                                      class="form-select mb-2"
                                      style="margin-left: 8px"
                                      aria-label="Default select example"
                                      [disabled]="!Ruler"
                                      [(ngModel)]="startTime"
                                      (change)="changeStartTimeOrder()"
                                    >
                                      <option
                                        *ngFor="let startTime of transactionTimeArray"
                                        value="{{ startTime.id }}"
                                      >
                                        {{ startTime.text }}
                                      </option>
                                    </select>
                                  </div>
                                  <div
                                    class="form-group d-flex align-items-center end-time"
                                  >
                                    <label class="text-end">End</label>
                                    <select
                                      class="form-select mb-2"
                                      style="margin-left: 15px"
                                      aria-label="Default select example"
                                      [disabled]="!Ruler"
                                      [(ngModel)]="endTime"
                                      (change)="changeEndTimeOrder()"
                                    >
                                      <option
                                        *ngFor="let endTime of transactionTimeArray"
                                        value="{{ endTime.id }}"
                                      >
                                        {{ endTime.text }}
                                      </option>
                                    </select>
                                  </div>
                                </div> -->
                              </div>
                              <div
                                *ngIf="OpenDetails === 'mainMenu'"
                                class="d-inline-block mb-14 in-bott"
                                (click)="OpenDetails = 'SelectPaymentmethod'"
                              >
                                <button
                                  type="button"
                                  class="btn f-14 fw-500 sec-btn"
                                  id="dropdownBasic1"
                                >
                                  {{ "Payment Methods" | translate | async }}
                                  <i class="fa-solid fa-chevron-right"></i>
                                </button>
                              </div>
                              <div
                                *ngIf="OpenDetails === 'mainMenu'"
                                class="d-inline-block in-bott mb-14"
                                (click)="OpenDetails = 'SelectEmployee'"
                              >
                                <button
                                  type="button"
                                  class="btn f-14 fw-500 sec-btn"
                                  id="dropdownBasic1"
                                >
                                  {{ "Employees" | translate | async }}
                                  <i class="fa-solid fa-chevron-right"></i>
                                </button>
                              </div>
                              <div
                                *ngIf="OpenDetails === 'mainMenu'"
                                class="d-inline-block in-bott mb-14"
                                (click)="OpenDetails = 'paymentStatus'"
                              >
                                <button
                                  type="button"
                                  class="btn f-14 fw-500 sec-btn"
                                  id="dropdownBasic1"
                                >
                                  {{ "Payment Status" | translate | async }}
                                  <i class="fa-solid fa-chevron-right"></i>
                                </button>
                              </div>
                              <div
                                *ngIf="OpenDetails === 'mainMenu'"
                                class="d-inline-block in-bott mb-14"
                                (click)="OpenDetails = 'SelectCard'"
                              >
                                <button
                                  type="button"
                                  class="btn f-14 fw-500 sec-btn"
                                  id="dropdownBasic1"
                                >
                                  {{ "Card" | translate | async }}
                                  <i class="fa-solid fa-chevron-right"></i>
                                </button>
                              </div>
  
                              <div
                                *ngIf="OpenDetails === 'mainMenu'"
                                class="d-inline-block in-bott mb-14"
                              >
                                <button
                                (click)="OpenDetails = 'cardtype'"
                                  type="button"
                                  class="btn f-14 fw-500 sec-btn"
                                  id="dropdownBasic1"
                                  *ngIf="cardTypeFilter == 'cardType'"
                                >
                                  {{ "Card Type" | translate | async }}
                                  <i class="fa-solid fa-chevron-right"></i>
                                </button>
                                <input
                                  *ngIf="cardTypeFilter == 'cardNumber'"
                                  class="form-control Iput_searc f-12"
                                  type="text"
                                  [(ngModel)]="salesCardNumber"
                                  maxlength="4"
                                  (ngModelChange)="FilterForCard($event,'change')"
                                  (keyup.enter)="FilterForCard($event,'enter')"
                                  [placeholder]="'Filter by Card(4 last digits)' | translate | async"
                                />
                              </div>
                              <!-- <div
                                *ngIf="OpenDetails === 'mainMenu'"
                                class="d-inline-block in-bott mb-14"
                              >
                                <button
                                  type="button"
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn f-14 fw-500 sec-btn"
                                  (click)="closeBatch()"
                                >
                                  {{ "Close Batch" | translate | async }}
                                </button>
                              </div> -->
                              <div
                                *ngIf="OpenDetails === 'mainMenu'"
                                class="d-inline-block in-bott"
                              >
                                <button
                                  (click)="OpenDetails = 'ExportDetails'"
                                  type="button"
                                  class="btn f-14 fw-500 sec-btn"
                                  id="dropdownBasic1"
                                >
                                  {{ "Export" | translate | async }}
                                  <i class="fa-solid fa-chevron-right"></i>
                                </button>
                              </div>
                              <!-- Select Payment status -->
                              <div *ngIf="OpenDetails === 'SelectPaymentmethod'">
                                <div class="">
                                  <div
                                    class="d-flex gap-14 align-items-center detalis mb-20"
                                    *ngIf="
                                      resultRevenueIds.length != paymentMethods.length
                                    "
                                  >
                                    <input
                                      type="checkbox"
                                      id="allPaymentMethods"
                                      class="form-check-input m-0"
                                      value="All Payment Methods"
                                      [checked]="checkedAll"
                                      (change)="checkAllRows()"
                                      (click)="$event.stopPropagation()"
                                    />
                                    <label
                                      for="allPaymentMethods"
                                      class="m-0 f-14 fw-500 text-gry"
                                      (click)="$event.stopPropagation()"
                                    >
                                      {{ "All Payment Methods" | translate | async }}
                                    </label>
                                  </div>
                                  <div
                                    class="d-flex gap-14 align-items-center detalis mb-20"
                                    *ngIf="
                                      resultRevenueIds.length == paymentMethods.length
                                    "
                                  >
                                    <input
                                      type="checkbox"
                                      id="allPaymentMethods2"
                                      class="form-check-input"
                                      value="All Payment Methods"
                                      [checked]="!checkedAll"
                                      (change)="uncheckAllRows()"
                                      (click)="$event.stopPropagation()"
                                    />
                                    <label
                                      for="allPaymentMethods2"
                                      class="m-0 f-14 fw-500 text-gry"
                                      (click)="$event.stopPropagation()"
                                    >
                                      {{ "All Payment Methods" | translate | async }}
                                    </label>
                                  </div>
                                </div>
                                <div class="" *ngFor="let payment of paymentMethods">
                                  <!-- <input type="checkbox" />
                                  <span class="f-14 fw-500">{{ payment.name }}</span> -->
                                  <div
                                    class="detalis mb-20 d-flex gap-14 align-items-center"
                                  >
                                    <input
                                      #cb3
                                      type="checkbox"
                                      id="paymentMethod{{ payment.id }}"
                                      class="form-check-input m-0"
                                      value="{{ payment.name }}"
                                      [checked]="findPaymentCheck(payment.id)"
                                      (change)="rowSelected(cb3, payment.id)"
                                      (click)="$event.stopPropagation()"
                                    />
                                    <label
                                      [for]="'paymentMethod' + payment.id"
                                      class="f-14 fw-500 mb-0"
                                      (click)="$event.stopPropagation()"
                                    >
                                      {{ payment.name | translate | async }}
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <!-- End payemt -->
                              <!-- select Employee -->
                              <div *ngIf="OpenDetails === 'SelectEmployee'">
                                <div class="">
                                  <!-- <input type="checkbox" />
                                  <p class="m-0 f-14 fw-500 text-gry">
                                    All Employees
                                  </p> -->
                                  <div
                                    class="d-flex gap-10 align-items-center detalis mb-20"
                                    *ngIf="
                                      resultEmployeeIds.length != employees$.length
                                    "
                                  >
                                    <input
                                      type="checkbox"
                                      id="allEmployees"
                                      class="form-check-input m-0"
                                      value="All Payment Methods"
                                      [checked]="checkedAll2"
                                      (change)="checkAllRowsEmployees()"
                                    />
                                    <label
                                      for="allEmployees"
                                      class="m-0 f-14 fw-500 text-gry"
                                    >
                                      {{ "All Employees" | translate | async }}
                                    </label>
                                  </div>
                                  <div
                                    class="d-flex gap-14 align-items-center detalis mb-20"
                                    *ngIf="
                                      resultEmployeeIds.length == employees$.length
                                    "
                                  >
                                    <input
                                      type="checkbox"
                                      id="allEmployees2"
                                      class="form-check-input"
                                      value="All Payment Methods"
                                      [checked]="!checkedAll2"
                                      (change)="uncheckAllRowsEmployees()"
                                    />
                                    <label
                                      for="allEmployees2"
                                      class="m-0 f-14 fw-500 text-gry"
                                    >
                                      {{ "All Employees" | translate | async }}
                                    </label>
                                  </div>
                                </div>
                                <div
                                  class="detalis mb-20 d-flex gap-14 align-items-center"
                                  *ngFor="let employee of activeEmployees$"
                                >
                                  <!-- <input type="checkbox" />
                                  <span class="f-14 fw-500">{{ employee.name }}</span> -->
  
                                  <div
                                    *ngIf="employee.status != 0"
                                    class="form-check-pink form-check"
                                  >
                                    <input
                                      #cb4
                                      type="checkbox"
                                      id="employee{{ employee.id }}"
                                      class="form-check-input"
                                      value="{{ employee.name }}"
                                      [checked]="findEmployeeCheck(employee.id)"
                                      (change)="
                                        rowSelectedEmployee(
                                          cb4,
                                          employee.id,
                                          employee.name
                                        )
                                      "
                                    />
                                    <label
                                      [for]="'employee' + employee.id"
                                      class="form-check-label m-0 f-14 fw-500 text-gry"
                                    >
                                      {{ employee.name | translate | async }} {{ employee.status | translate | async }}</label
                                    >
                                  </div>
                                </div>
                              </div>
                              <!-- End Employee -->
                              <!-- select Employee -->
                              <div *ngIf="OpenDetails === 'paymentStatus'">
                                <div class="" *ngFor="let payment of NewPaymentStaus">
                                  <div
                                    class="detalis mb-20 d-flex gap-14 align-items-center"
                                    (click)="NewchangePaymentstatus(payment.value)"
                                  >
                                    <span class="f-14 fw-500">{{
                                      payment.name
                                    }}</span>
                                  </div>
                                </div>
                              </div>
                              <!-- End paymentstauts -->
                              <!-- Select card  -->
                              <div *ngIf="OpenDetails === 'SelectCard'">
                                <div
                                  class="detalis mb-20 d-flex gap-14 align-items-center"
                                >
                                  <span
                                    class="f-14 fw-500"
                                    (click)="NewchangeCardFilter('1')"
                                    >{{ "Card" | translate | async }}</span
                                  >
                                </div>
                                <div
                                  class="detalis mb-20 d-flex gap-14 align-items-center"
                                >
                                  <span
                                    class="f-14 fw-500"
                                    (click)="NewchangeCardFilter('2')"
                                    >{{ "Number" | translate | async }}</span
                                  >
                                </div>
                              </div>
                              <!-- End Card -->
                              <div>
                                <div *ngIf="OpenDetails === 'cardtype'">
                                  <div class="" *ngFor="let p of NewcardType">
                                    <div
                                      class="detalis mb-20 d-flex gap-14 align-items-center"
                                      (click)="NewFilterByCardType(p.value)"
                                    >
                                      <span class="f-14 fw-500">{{ p.name }}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- Export -->
                            <div>
                              <div class="" *ngIf="OpenDetails === 'ExportDetails'">
                                <div
                                  class="d-flex align-items-center gap-12 p-btn"
                                  (click)="exportReport('pdf')"
                                >
                                  <img src="/assets/images/pdf-expo.svg" alt="expo" />
                                  <p class="f-14 fw-500 black mb-0">{{ "Export PDF" | translate | async }}</p>
                                </div>
                                <div
                                  class="d-flex align-items-center gap-12 p-btn"
                                  (click)="exportReport('csv')"
                                >
                                  <img src="/assets/images/csv-expo.svg" alt="expo" />
                                  <p class="f-14 fw-500 black mb-0">{{ "Export CSV" | translate | async }}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                  <div class="col-auto col-report mob-report">
                    <div class="input-group SetZindex-main">
                      <!-- NEW DATE-TIME FILTER -->
                      <div
                      ngbDropdown
                      #myDrop="ngbDropdown"
                      class="d-inline-block in-bott"
  
                    >
                      <button
                        type="button"
                        class="btn f-12 fw-500 sec-btn"
                        id="dropdownBasic1"
                        ngbDropdownToggle
  
                      >
                        {{ startTimeFormatted | translate | async }} - {{ endTimeFormatted | translate | async }}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="icon icon-tabler icon-tabler-chevron-down"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          stroke-width="2"
                          stroke="currentColor"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          [class.rotate-up]="myDrop.isOpen()"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </button>
                      <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                        <div class="d-flex justify-content-between f-12 fw-500">
                          <div class="me-2 ms-2 mt-3">
                            <p>{{ "Start" | translate | async }}</p>
                          </div>
                          <div class="p-2 start-Date-new position-relative">
                            <ng-select
                              class="form-select f-12 fw-500"
                              id="Select1"
                              [(ngModel)]="startTime"
                              style="width: 100px !important;"
                            >
                              <ng-option
                                [value]="startDate.id"
                                *ngFor="let startDate of dateTimeArray"
                              >
                                {{ startDate.text }}
                              </ng-option>
                            </ng-select>
                          </div>
                        </div>
                        <div class="d-flex justify-content-between f-12 fw-500">
                          <div class="me-2 ms-2 mt-3">
                            <p>{{ "End" | translate | async }}</p>
                          </div>
                          <div class="p-2 End-Date-new position-relative">
                            <ng-select
                              id="Select2"
                              [(ngModel)]="endTime"
                              class="form-select f-12 fw-500"
                              style="width: 100px !important;"
                            >
                              <ng-option
                                [value]="endDate.id"
                                *ngFor="let endDate of dateTimeArray"
                              >
                                {{ endDate.text }}
                              </ng-option>
                            </ng-select>
                          </div>
                        </div>
                        <div class="d-flex justify-content-between f-12 fw-500">
                          <div class="me-2 ms-2 mt-1">
                            <input
                              class="form-check-input custom-form-radio me-2"
                              type="radio"
                              id="Second1"
                              value="Same Day"
                              [(ngModel)]="ClosingDay"
                              [checked]="sameDayIsChecked()"
                              (ngModelChange)="selectClosingDay($event)"
                            />
                            <label class="form-check-label" for="Second1">
                              {{ "Same Day" | translate | async }}
                            </label>
                          </div>
                        </div>
                        <div class="d-flex justify-content-between f-12 fw-500">
                          <div class="me-2 ms-2 mt-1">
                            <input
                              class="form-check-input custom-form-radio me-2"
                              type="radio"
                              id="Second2"
                              name="closingDay"
                              value="Next Day"
                              [(ngModel)]="ClosingDay"
                              [checked]="nextDayIsChecked()"
                              (ngModelChange)="selectClosingDay($event)"
                            />
                            <label class="form-check-label" for="Second2">
                              {{ "Next Day" | translate | async }}
                              <i
                                class="f-10 fas fa-info-circle vertical-align-super"
                                [ngbPopover]="'Generate your reports for same day or next day (allowing custom 24 hour range) based on the restaurants daily hours of operation' | translate | async"
                                triggers="mouseenter:mouseleave"
                                [popoverTitle]="'Next Day' | translate | async"
                                data-bs-placement="right"
                              ></i>
                            </label>
                          </div>
                        </div>
                        <div class="f-12 fw-500">
                          <div class="me-2 ms-2 mt-1">
                            <button
                              class="btn btn-dark btn-block btn-sm w-100"
                              (click)="timeFilter(); myDrop.close()"
                              [disabled]="
                                (ClosingDay == 'Next Day' &&
                                  startDateDisplay == endDateDisplay) ||
                                (ClosingDay == 'Same Day' &&
                                  timeDiasbleValidation())
                              "
                            >
                              {{ "Apply" | translate | async }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                      <!-- <div
                        ngbDropdown
                        #myDrop="ngbDropdown"
                        class="d-inline-block mb-3 in-bott"
                      >
                        <button
                          (click)="isDropdownOpen1 = !isDropdownOpen1"
                          type="button"
                          class="btn f-12 fw-500 sec-btn"
                          id="dropdownBasic1"
                          ngbDropdownToggle
                          (blur)="isDropdownOpen1 = false"
                        >
                          {{ startTimeFormatted }} - {{ endTimeFormatted }}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="icon icon-tabler icon-tabler-chevron-down"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            stroke-width="2"
                            stroke="currentColor"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            [class.rotate-up]="isDropdownOpen1"
                          >
                            <path
                              stroke="none"
                              d="M0 0h24v24H0z"
                              fill="none"
                            ></path>
                            <polyline points="6 9 12 15 18 9"></polyline>
                          </svg>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                          <div class="d-flex justify-content-between f-12 fw-500">
                            <div class="me-2 ms-2 mt-3">
                              <p>Start</p>
                            </div>
                            <div class="p-2 start-Date-new">
                              <ng-select
                                class="form-select f-12 fw-500"
                                id="Select1"
                                [(ngModel)]="startTime"
                              >
                                <ng-option
                                  [value]="startDate.id"
                                  *ngFor="let startDate of dateTimeArray"
                                >
                                  {{ startDate.text }}
                                </ng-option>
                              </ng-select>
                            </div>
                          </div>
                          <div class="d-flex justify-content-between f-12 fw-500">
                            <div class="me-2 ms-2 mt-3">
                              <p>End</p>
                            </div>
                            <div class="p-2 End-Date-new">
                              <ng-select
                                id="Select2"
                                [(ngModel)]="endTime"
                                class="form-select f-12 fw-500"
                              >
                                <ng-option
                                  [value]="endDate.id"
                                  *ngFor="let endDate of dateTimeArray"
                                >
                                  {{ endDate.text }}
                                </ng-option>
                              </ng-select>
                            </div>
                          </div>
                          <div class="d-flex justify-content-between f-12 fw-500">
                            <div class="me-2 ms-2 mt-1">
                              <input
                                class="form-check-input custom-form-radio me-2"
                                type="radio"
                                id="Second1"
                                value="Same Day"
                                [(ngModel)]="ClosingDay"
                                [checked]="sameDayIsChecked()"
                                (ngModelChange)="selectClosingDay($event)"
                              />
                              <label class="form-check-label" for="Second2">
                                Same Day
                              </label>
                            </div>
                          </div>
                          <div class="d-flex justify-content-between f-12 fw-500">
                            <div class="me-2 ms-2 mt-1">
                              <input
                                class="form-check-input custom-form-radio me-2"
                                type="radio"
                                id="Second2"
                                name="closingDay"
                                value="Next Day"
                                [(ngModel)]="ClosingDay"
                                [checked]="nextDayIsChecked()"
                                (ngModelChange)="selectClosingDay($event)"
                              />
                              <label class="form-check-label" for="Second2">
                                Next Day
                                <i
                                  class="f-10 fas fa-info-circle vertical-align-super"
                                  ngbPopover="Generate your reports for same day or next day (allowing custom 24 hour range) based on the restaurants daily hours of operation"
                                  triggers="mouseenter:mouseleave"
                                  popoverTitle="Next Day"
                                  data-bs-placement="right"
                                ></i>
                              </label>
                            </div>
                          </div>
                          <div class="f-12 fw-500">
                            <div class="me-2 ms-2 mt-1">
                              <button
                                class="btn btn-dark btn-block btn-sm w-100"
                                (click)="timeFilter(); myDrop.close()"
                                [disabled]="
                                  (ClosingDay == 'Next Day' &&
                                    startDateDisplay == endDateDisplay) ||
                                  (ClosingDay == 'Same Day' &&
                                    timeDiasbleValidation())
                                "
                              >
                                Apply
                              </button>
                            </div>
                          </div>
                        </div>
                      </div> -->
  
                      <!-- <div
                        accessControl
                        module="SalesTransaction"
                        access="3"
                        ngbDropdown
                        #myDrop="ngbDropdown"
                        display="dynamic"
                        container="body"
                        class="d-inline-block w-100"
                      >
                        <button
                          accessControl
                          module="SalesTransaction"
                          access="3"
                          type="button"
                          class="btn f-12 fw-500 sec-btn"
                          style="z-index: 0 !important"
                          id="dropdownBasic2"
                          ngbDropdownToggle
                        >
                          <span *ngIf="Ruler == false">Day Part</span>
                          <span *ngIf="Ruler != false"
                            >{{ startTimeFormatted }} - {{ endTimeFormatted }}</span
                          >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="icon icon-tabler icon-tabler-chevron-down ms-3"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            stroke-width="2"
                            stroke="currentColor"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path
                              stroke="none"
                              d="M0 0h24v24H0z"
                              fill="none"
                            ></path>
                            <polyline points="6 9 12 15 18 9"></polyline>
                          </svg>
                        </button>
                        <div
                          ngbDropdownMenu
                          aria-labelledby="dropdownBasic2"
                          class="p-2"
                        >
                          <div class="form-check" (click)="clickDayAllOption()">
                            <input
                              class="form-check-input"
                              checked
                              type="radio"
                              name="daygroup"
                              id="allday"
                            />
                            <label class="form-check-label" for="allday">
                              All Day
                            </label>
                          </div>
                          <div class="dropdown-divider"></div>
                          <div
                            class="form-check mb-2"
                            (click)="clickCustomizeOption()"
                          >
                            <input
                              class="form-check-input"
                              type="radio"
                              name="daygroup"
                              id="custom"
                            />
                            <label class="form-check-label" for="custom">
                              Custom
                            </label>
                          </div>
                          <div
                            class="form-group d-flex align-items-center start-time"
                          >
                            <label class="text-end">Start</label>
                            <select
                              class="form-select mb-2"
                              style="margin-left: 8px"
                              aria-label="Default select example"
                              [disabled]="!Ruler"
                              [(ngModel)]="startTime"
                              (change)="changeStartTimeOrder($event)"
                            >
                              <option
                                *ngFor="let startTime of transactionTimeArray"
                                value="{{ startTime.id }}"
                              >
                                {{ startTime.text }}
                              </option>
                            </select>
                          </div>
                          <div
                            class="form-group d-flex align-items-center end-time"
                          >
                            <label class="text-end">End</label>
                            <select
                              class="form-select mb-2"
                              style="margin-left: 15px"
                              aria-label="Default select example"
                              [disabled]="!Ruler"
                              [(ngModel)]="endTime"
                              (change)="changeEndTimeOrder($event)"
                            >
                              <option
                                *ngFor="let endTime of transactionTimeArray"
                                value="{{ endTime.id }}"
                              >
                                {{ endTime.text }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div> -->
                    </div>
                  </div>
                  <div class="col-auto col-report mob-report">
                    <div class="input-group in-bott">
                      <div
                        accessControl
                        module="SalesTransaction"
                        access="3"
                        ngbDropdown
                        #paymentDrop="ngbDropdown"
                        display="dynamic"
                        container="body"
                        class="d-inline-block w-100"
                      >
                        <!--
                          Removed: [disabled]="transactions$.length === 0" - ED-1243
                        -->
                        <button
                          accessControl
                          module="SalesTransaction"
                          access="3"
                          type="button"
                          class="btn f-12 fw-500 sec-btn"
                          style="z-index: 0 !important"
                          id="dropdownBasic6"
                          ngbDropdownToggle
                          (click)="EmployeeArrowChange('payment')"
                          (blur)="paymentMethodeErr = false"
                        >
                          <span>{{ "Payment Methods" | translate | async }}</span>
                          <svg
  
                            xmlns="http://www.w3.org/2000/svg"
                            class="icon icon-tabler icon-tabler-chevron-down ms-3"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            stroke-width="2"
                            stroke="currentColor"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            [class.rotate-up]="paymentMethodeErr"
                          >
                            <path
                              stroke="none"
                              d="M0 0h24v24H0z"
                              fill="none"
                            ></path>
                            <polyline points="6 9 12 15 18 9"></polyline>
                          </svg>
                          <!-- <svg
                            *ngIf="isExportOpen"
                            stroke-width="2"
                            width="10"
                            height="10"
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            viewBox="0 0 330 330"
                            xml:space="preserve"
                          >
                            <path
                              id="XMLID_224_"
                              d="M325.606,229.393l-150.004-150C172.79,76.58,168.974,75,164.996,75c-3.979,0-7.794,1.581-10.607,4.394
      l-149.996,150c-5.858,5.858-5.858,15.355,0,21.213c5.857,5.857,15.355,5.858,21.213,0l139.39-139.393l139.397,139.393
      C307.322,253.536,311.161,255,315,255c3.839,0,7.678-1.464,10.607-4.394C331.464,244.748,331.464,235.251,325.606,229.393z"
                            />
                          </svg> -->
                        </button>
                        <div
                          ngbDropdownMenu
                          aria-labelledby="dropdownBasic6"
                          class="payment-method-menu p-2"
                        >
                          <a
                            class="dropdown-item"
                            style="padding: 0 !important"
                            href="javascript:void(0)"
                          >
                            <label
                              [for]="
                                resultRevenueIds.length != paymentMethods.length
                                  ? 'allPaymentMethods'
                                  : 'allPaymentMethods2'
                              "
                              style="
                                width: 100%;
                                padding: 0.25rem;
                                margin-bottom: 0 !important;
                              "
                            >
                              <div
                                class="form-check-pink form-check"
                                *ngIf="
                                  resultRevenueIds.length != paymentMethods.length
                                "
                              >
                                <input
                                  type="checkbox"
                                  id="allPaymentMethods"
                                  class="form-check-input"
                                  value="All Payment Methods"
                                  [checked]="checkedAll"
                                  (change)="checkAllRows()"
                                />
                                <label
                                  for="allPaymentMethods"
                                  class="form-check-label text-dark"
                                >
                                  {{ "All Payment Methods" | translate | async }}
                                </label>
                              </div>
                              <div
                                class="form-check-pink form-check"
                                *ngIf="
                                  resultRevenueIds.length == paymentMethods.length
                                "
                              >
                                <input
                                  type="checkbox"
                                  id="allPaymentMethods2"
                                  class="form-check-input"
                                  value="All Payment Methods"
                                  [checked]="!checkedAll"
                                  (change)="uncheckAllRows()"
                                />
                                <label
                                  for="allPaymentMethods2"
                                  class="form-check-label text-dark"
                                >
                                  {{ "All Payment Methods" | translate | async }}
                                </label>
                              </div>
                            </label>
                          </a>
                          <a
                            class="dropdown-item"
                            style="padding: 0 !important"
                            href="javascript:void(0)"
                            *ngFor="let method of paymentMethods"
                          >
                            <label
                              [for]="'paymentMethod' + method.id"
                              style="
                                width: 100%;
                                padding: 0.25rem;
                                margin-bottom: 0 !important;
                              "
                            >
                              <div class="form-check-pink form-check">
                                <input
                                  #cb3
                                  type="checkbox"
                                  id="paymentMethod{{ method.id }}"
                                  class="form-check-input"
                                  value="{{ method.name }}"
                                  [checked]="findPaymentCheck(method.id)"
                                  (change)="rowSelected(cb3, method.id)"
                                />
                                <label
                                  [for]="'paymentMethod' + method.id"
                                  class="form-check-label text-dark"
                                >
                                  {{
                                    method.name | translate | async
                                  }}
                                </label>
                              </div>
                            </label>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-auto col-report mob-report">
                    <div class="input-group in-bott">
                      <div
                        accessControl
                        module="SalesTransaction"
                        (click)="EmployeeArrowChange('Employee')"
                        access="3"
                        ngbDropdown
                        #employeeDrop="ngbDropdown"
                        display="dynamic"
                        container="body"
                        class="d-inline-block w-100"
                        (blur)="IsEmployeeeError = false"
                      >
                        <!--
                          Removed: [disabled]="transactions$.length === 0" - ED-1243
                        -->
                        <button
                          accessControl
                          module="SalesTransaction"
                          access="3"
                          type="button"
                          class="btn f-12 fw-500 sec-btn"
                          style="z-index: 0 !important"
                          id="dropdownBasic4"
                          ngbDropdownToggle
                        >
                          <span class="employee-line-full">
                            {{
                              finalresultPaymentsNames === ""
                                ? ("Employees" | translate | async)
                                : finalresultPaymentsNames
                            }}</span
                          >
                          <!-- <span>Employees</span> -->
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="icon icon-tabler icon-tabler-chevron-down ms-3"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            stroke-width="2"
                            stroke="currentColor"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            [class.rotate-up]="IsEmployeeeError"
                          >
                            <path
                              stroke="none"
                              d="M0 0h24v24H0z"
                              fill="none"
                            ></path>
                            <polyline points="6 9 12 15 18 9"></polyline>
                          </svg>
                        </button>
                        <div
                          ngbDropdownMenu
                          aria-labelledby="dropdownBasic4"
                          class="payment-method-menu p-2"
                        >
                          <a
                            class="dropdown-item"
                            style="padding: 0 !important"
                            href="javascript:void(0)"
                          >
                            <label
                              [for]="
                                resultEmployeeIds.length != employees$.length
                                  ? 'allEmployees'
                                  : 'allEmployees2'
                              "
                              style="
                                width: 100%;
                                padding: 0.25rem;
                                margin-bottom: 0 !important;
                              "
                            >
                              <div
                                class="form-check-pink form-check"
                                *ngIf="
                                  resultEmployeeIds.length != employees$.length
                                "
                              >
                                <input
                                  type="checkbox"
                                  id="allEmployees"
                                  class="form-check-input"
                                  value="All Payment Methods"
                                  [checked]="checkedAll2"
                                  (change)="checkAllRowsEmployees()"
                                />
                                <label
                                  for="allEmployees"
                                  class="form-check-label text-dark"
                                >
                                  {{ "All Employees" | translate | async }}
                                </label>
                              </div>
                              <div
                                class="form-check-pink form-check"
                                *ngIf="
                                  resultEmployeeIds.length == employees$.length
                                "
                              >
                                <input
                                  type="checkbox"
                                  id="allEmployees2"
                                  class="form-check-input"
                                  value="All Payment Methods"
                                  [checked]="!checkedAll2"
                                  (change)="uncheckAllRowsEmployees()"
                                />
                                <label
                                  for="allEmployees2"
                                  class="form-check-label text-dark"
                                >
                                  {{ "All Employees" | translate | async }}
                                </label>
                              </div>
                            </label>
                          </a>
                          <a
                            class="dropdown-item"
                            style="padding: 0 !important"
                            href="javascript:void(0)"
                            *ngFor="let employee of activeEmployees$"
                          >
                            <label
                              [for]="'employee' + employee.id"
                              style="
                                width: 100%;
                                padding: 0.25rem;
                                margin-bottom: 0 !important;
                              "
                            >
                              <div
                                *ngIf="employee.status != 0"
                                class="form-check-pink form-check"
                              >
                                <input
                                  #cb4
                                  type="checkbox"
                                  id="employee{{ employee.id }}"
                                  class="form-check-input"
                                  value="{{ employee.name }}"
                                  [checked]="findEmployeeCheck(employee.id)"
                                  (change)="
                                    rowSelectedEmployee(
                                      cb4,
                                      employee.id,
                                      employee.name
                                    )
                                  "
                                />
                                <label
                                  [for]="'employee' + employee.id"
                                  class="form-check-label text-dark"
                                >
                                  {{ employee.name | translate | async }} {{ employee.status | translate | async }}</label
                                >
                              </div>
                            </label>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-auto col-report drop-per mob-report">
                    <div class="d-flex flex-wrap align-items-baseline gap-4 w-100">
                      <div class="searchinput spermiss w-100">
                        <div class="col-auto d-flex right_part f-12">
                          <div
                            class="right_part w-100 position-relative"
                            (blur)="paymentStausErr = false"
                            (click)="paymentStausErr = !paymentStausErr"
                          >
                            <!-- #NEW FILTERS -->
                            <select
                              type="select"
                              class="select-location selectborder2 w-100 custom-select"
                              (change)="changePaymentstatus($event)"
                            >
                              <option selected value="">{{ "Payment Status" | translate | async }}</option>
                              <option value="1">{{ "Approved" | translate | async }}</option>
                              <option value="2">{{ "Partial Refund" | translate | async }}</option>
                              <option value="3">{{ "Refunded" | translate | async }}</option>
                              <option value="4">{{ "Refund" | translate | async }}</option>
                              <option value="5">{{ "Deposited" | translate | async }}</option>
                              <option value="6">{{ "Void" | translate | async }}</option>
                            </select>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="down-arrow icon-tabler-chevron-down ms-3 select-dropdown"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              stroke-width="2"
                              stroke="currentColor"
                              fill="none"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              [class.rotate-up1]="paymentStausErr"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              ></path>
                              <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-auto col-report drop-trac mob-report">
                    <div class="right_part w-100 position-relative search_box position-relative">
                      <select
                        type="select"
                        class="select-location selectborder2 w-100 f-12 custom-select"
                        (change)="changeCardFilter($event)"
                        (blur)="isDropdownOpen2 = false"
                        (click)="isDropdownOpen2 = !isDropdownOpen2"
                      >
                        <option value="1">{{ "Card" | translate | async }}</option>
                        <option value="2">{{ "Number" | translate | async }}</option>
                      </select>
                      <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon-tabler icon-tabler-chevron-down ms-3 discount-select-arrow-new"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      [class.rotate-up]="isDropdownOpen2"
                    >
                      <path
                        stroke="none"
                        d="M0 0h24v24H0z"
                        fill="none"
                      ></path>
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                    </div>
                  </div>
                  <div
                    class="col-auto col-report d-flex f-12 gap-2 drop-trac mob-report"
                  >
                    <div class="search_box w-100">
                      <!-- <div id="searchlist" (click)="AddedInputCss()">
                              <i class="fa-solid fa-magnifying-glass search_icon"></i>
                            </div> -->
  
  
                      <div class="position-relative"
  
                      >
                        <select
                          type="select"
                          [(ngModel)]="SelectedCardType"
                          class="select-location selectborder2 w-100"
                          *ngIf="cardTypeFilter == 'cardType'"
                          (change)="FilterByCardType($event)"
                          (click)="IsActiveselectCard = !IsActiveselectCard"
                          (blur)="IsActiveselectCard = false"
                        >
                          <option selected value="">{{ "Card Type" | translate | async }}</option>
                          <option value="24">{{ "Visa" | translate | async }}</option>
                          <option value="23">{{ "Master Card" | translate | async }}</option>
                          <option value="22">{{ "Discover" | translate | async }}</option>
                          <option value="21">{{ "Amex" | translate | async }}</option>
                          <option value="25">{{ "Unknown" | translate | async }}</option>
                        </select>
                        <div class="" *ngIf="cardTypeFilter != 'cardNumber'">
                          <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon-tabler icon-tabler-chevron-down ms-3 discount-select-arrow-new"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      [class.rotate-up]="IsActiveselectCard"
                    >
                      <path
                        stroke="none"
                        d="M0 0h24v24H0z"
                        fill="none"
                      ></path>
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                        </div>
                      </div>
  
                      <input
                        *ngIf="cardTypeFilter == 'cardNumber'"
                        class="form-control Iput_searc f-12"
                        type="text"
                        [(ngModel)]="salesCardNumber"
                        maxlength="4"
                        (ngModelChange)="FilterForCard($event,'change')"
                        (keyup.enter)="FilterForCard($event,'enter')"
                        [placeholder]="'Filter by Card (4 last digits)' | translate | async"
                      />
                    </div>
                  </div>
                  <!-- <button
                    accessControl
                    module="SalesTransaction"
                    access="3"
                    [disabled]="transactions$.length === 0"
                    class="btn f-12 fw-500 sec-btn col-report mob-report"
                    (click)="closeBatch()"
                  >
                    <span>{{ "Close Batch" | translate | async }}</span>
                  </button> -->
                  <!-- <div class="d-flex align-items-baseline flex-wrap gap-sm-2 w-100">
                    <div
                      class="searchinput spermiss mb-3 d-sm-flex right_part f-12 gap-2"
                    >
                      <div class="col-auto col-report mb-sm-0 mb-3">
                        <div class="right_part w-100 position-relative search_box">
                          <select
                            type="select"
                            class="select-location selectborder2 w-100"
                            (change)="changeCardFilter($event)"
                          >
                            <option value="1">Card</option>
                            <option value="2">Number</option>
                          </select>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="down-arrow icon-tabler-chevron-down ms-3"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            stroke-width="2"
                            stroke="currentColor"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                            <polyline points="6 9 12 15 18 9"></polyline>
                          </svg>
                        </div>
                      </div>
                      <div class="col-auto col-report d-flex f-12 gap-2">
                        <div class="search_box w-100">
                          <div id="searchlist" (click)="AddedInputCss()">
                              <i class="fa-solid fa-magnifying-glass search_icon"></i>
                            </div>
  
                          <div class="position-relative">
                            <select
                              type="select"
                              [(ngModel)]="SelectedCardType"
                              class="select-location selectborder2 w-100"
                              *ngIf="cardTypeFilter == 'cardType'"
                              (change)="FilterByCardType($event)"
                            >
                              <option selected value="">CardType</option>
                              <option value="24">Visa</option>
                              <option value="23">Master Card</option>
                              <option value="22">Discover</option>
                              <option value="21">Amex</option>
                              <option value="25">Unknown</option>
                            </select>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="down-arrow icon-tabler-chevron-down ms-3"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              stroke-width="2"
                              stroke="currentColor"
                              fill="none"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              ></path>
                              <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                          </div>
  
                          <input
                            *ngIf="cardTypeFilter == 'cardNumber'"
                            class="form-control Iput_searc f-12"
                            type="text"
                            [(ngModel)]="salesCardNumber"
                            maxlength="4"
                            (ngModelChange)="FilterForCard($event)"
                            (keyup.enter)="FilterForCard($event)"
                            placeholder="Filter by Card(4 last digits)"
                            style="width: 205px"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="d-sm-flex gap-2 align-items-baseline">
                      <button
                        accessControl
                        module="SalesTransaction"
                        access="3"
                        class="btn f-12 fw-500 sec-btn col-report mb-sm-0 mb-3"
                        (click)="closeBatch()"
                      >
                        <span>Close Batch</span>
                      </button>
                      <div class="col-auto col-report">
                        <div class="input-group mb-3 w-100">
                          <div
                            accessControl
                            module="SalesTransaction"
                            access="3"
                            ngbDropdown
                            display="dynamic"
                            container="body"
                            class="d-inline-block w-100 in-bott"
                          >
                            <button
                              accessControl
                              module="SalesTransaction"
                              access="3"
                              [disabled]="summary$.transactions === 0"
                              class="btn f-12 fw-500 sec-btn w-100"
                              style="z-index: 0 !important"
                              id="dropdownBasic3"
                              ngbDropdownToggle
                            >
                              <span>Export</span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="icon icon-tabler icon-tabler-chevron-down ms-3"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                stroke-width="2"
                                stroke="currentColor"
                                fill="none"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              >
                                <path
                                  stroke="none"
                                  d="M0 0h24v24H0z"
                                  fill="none"
                                ></path>
                                <polyline points="6 9 12 15 18 9"></polyline>
                              </svg>
                            </button>
                            <div
                              ngbDropdownMenu
                              aria-labelledby="dropdownBasic3"
                              class="p-2"
                            >
                              <a
                                ngbDropdownItem
                                href="javascript: void (0)"
                                (click)="exportReport('pdf')"
                                class="text-dark"
                              >
                                <i class="fas fa-file-pdf"></i>
                                <span>&nbsp;&nbsp;Export PDF</span>
                              </a>
                              <div class="dropdown-divider"></div>
                              <a
                                ngbDropdownItem
                                href="javascript: void (0)"
                                (click)="exportReport('csv')"
                                class="text-dark"
                              >
                                <i class="fas fa-file-csv"></i>
                                <span>&nbsp;&nbsp;Export CSV</span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
              <div class="col-auto export-data mob-report">
                <div class="input-group w-100">
                  <div
                    accessControl
                    module="SalesTransaction"
                    access="3"
                    ngbDropdown
                    display="dynamic"
                    container="body"
                    class="d-inline-block w-100 in-bott"
                  >
                    <button
                      *ngIf="transactions$.length === 0"
                      module="SalesTransaction"
                      disabled
                      class="btn f-12 fw-500 sec-btn w-100"
                      style="z-index: 0 !important"
                      id="dropdownBasic3"
                    >
                      {{ "Export" | translate | async }}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-chevron-down ms-3"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        [class.rotate-up]="isDropdownOpen"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <polyline points="6 9 12 15 18 9"></polyline>
                      </svg>
                    </button>
                    <button
                      *ngIf="transactions$.length !== 0"
                      accessControl
                      module="SalesTransaction"
                      (click)="toggleDropdown()"
                      access="3"
                      class="btn f-12 fw-500 sec-btn w-100"
                      style="z-index: 0 !important"
                      id="dropdownBasic3"
                      ngbDropdownToggle
                      (blur)="isDropdownOpen = false"
                    >
                      <span>{{ "Export" | translate | async }}</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-chevron-down ms-3"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        [class.rotate-up]="isDropdownOpen"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <polyline points="6 9 12 15 18 9"></polyline>
                      </svg>
                    </button>
                    <div
                      ngbDropdownMenu
                      aria-labelledby="dropdownBasic3"
                      class="p-2"
                    >
                      <a
                        ngbDropdownItem
                        href="javascript: void (0)"
                        (click)="exportReport('pdf')"
                        class="text-dark"
                        [ngStyle]="{
                          'pointer-events':
                            transactions$.length === 0 ? 'none' : 'auto'
                        }"
                      >
                        <i class="fas fa-file-pdf"></i>
                        <span>&nbsp;&nbsp;{{ "Export PDF" | translate | async }}</span>
                      </a>
                      <div class="dropdown-divider"></div>
                      <a
                        ngbDropdownItem
                        href="javascript: void (0)"
                        (click)="exportReport('csv')"
                        class="text-dark"
                        [ngStyle]="{
                          'pointer-events':
                            transactions$.length === 0 ? 'none' : 'auto'
                        }"
                      >
                        <i class="fas fa-file-csv"></i>
                        <span>&nbsp;&nbsp;{{ "Export CSV" | translate | async }}</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="transaction-table mt-2 order-data d-grid"
              *ngIf="transactions$.length != 0"
            >
              <div class="table-responsive">
                <table class="display dataTable no-footer">
                  <thead>
                    <tr>
                      <th class="text-center">{{ "Order No." | translate | async }}</th>
                      <th class="text-center">{{ "Date Created" | translate | async }}</th>
                      <th class="text-center">{{ "Time" | translate | async }}</th>
                      <th class="text-center">{{ "Transaction ID" | translate | async }}</th>
                      <th class="text-center">{{ "Payment ID" | translate | async }}</th>
                      <th class="text-center">{{ "Employee" | translate | async }}</th>
                      <th class="text-center">{{ "Type" | translate | async }}</th>
                      <th class="text-center">{{ "Status" | translate | async }}</th>
                      <th class="text-center">{{ "Amount" | translate | async }}</th>
                    </tr>
                  </thead>
                  <tbody class="fw-500">
                    <ng-container
                      *ngFor="
                        let payment of sortData(transactions$)
                          | paginate
                            : {
                                itemsPerPage: itemsPP,
                                currentPage: p,
                                totalItems: metaData$.ordersTotal
                              };
                        let x = index
                      "
                    >
                      <ng-container
                        *ngIf="
                          payment.transactionIds.length > 0 && payment.orderId
                        "
                      >
                        <ng-container
                          *ngIf="payment.toggle || payment.toggle == true"
                        >
                          <ng-container
                            *ngFor="
                              let transaction of payment.transactionIds;
                              let i = index
                            "
                          >
                            <tr
                              [ngClass]="{
                                borderBottomTable:
                                  payment.transactionIds.length == 1
                              }"
                              (click)="seePaymentReceipt(content, payment, x)"
                            >
                              <td (click)="toggleTable(x)" class="p-0">
                                <div *ngIf="i == 0" class="position-relative">
                                  <div
                                    class="position-absolute"
                                    style="left: 5px"
                                  >
                                    <span
                                      *ngIf="payment.transactionIds.length > 1"
                                      class="dropdown-icon"
                                    >
                                      <i class="mdi mdi-menu-up"></i>
                                    </span>
                                  </div>
                                  <div>
                                    <span
                                      *ngIf="payment.orderId"
                                      [ngClass]="{
                                        rightSpan:
                                          payment.transactionIds.length > 1
                                      }"
                                      >{{ payment.orderId.orderNumber }}</span
                                    >
                                    <span *ngIf="!payment.orderId">---</span>
                                  </div>
                                </div>
                                <div *ngIf="i != 0">
                                  <div style="visibility: hidden">
                                    <span
                                      *ngIf="payment.transactionIds.length > 1"
                                      class="dropdown-icon"
                                    >
                                      <i class="mdi mdi-menu-up"></i>
                                    </span>
                                    <span
                                      *ngIf="payment.orderId"
                                      [ngClass]="{
                                        rightSpan:
                                          payment.transactionIds.length > 1
                                      }"
                                    >
                                      {{ payment.orderId.orderNumber }}</span
                                    >
                                    <span *ngIf="!payment.orderId">---</span>
                                  </div>
                                </div>
                              </td>
                              <td
                                class=""
                                [ngClass]="{
                                  redLettersRefund:
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionStatus == 2 ||
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionStatus == 4
                                }"
                              >
                                <span *ngIf="payment.transactions">
                                  {{
                                    convertDate(
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1 - i
                                      ].createdAt
                                    ) | translate | async
                                  }}
                                </span>
                                <span *ngIf="!payment.transactions">
                                  {{ convertDate(payment.createdAt) | translate | async }}
                                </span>
                              </td>
                              <td
                                class=""
                                [ngClass]="{
                                  redLettersRefund:
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionStatus == 2 ||
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionStatus == 4
                                }"
                              >
                                <span *ngIf="payment.transactionIds">
                                  {{
                                    convertTime(
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1 - i
                                      ].createdAt
                                    ) | translate | async
                                  }}
                                </span>
                                <span *ngIf="!payment.transactionIds">
                                  {{ convertTime(payment.createdAt) | translate | async }}
                                </span>
                              </td>
                              <td
                                class=""
                                [ngClass]="{
                                  redLettersRefund:
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionStatus == 2 ||
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionStatus == 4
                                }"
                              >
                                <span *ngIf="payment.transactionIds">
                                  {{
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionNumber
                                  }}
                                </span>
                                <span *ngIf="!payment.transactionIds"></span>
                              </td>
                              <td
                                class=""
                                [ngClass]="{
                                  redLettersRefund:
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionStatus == 2 ||
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionStatus == 4
                                }"
                              >
                                <span>
                                  <!-- {{payment.paymentNumber}} -->
                                  {{ payment.payId }}
                                </span>
                              </td>
                              <td class="">
                                <span
                                  *ngIf="payment.orderId.serverId !== null"
                                  style="
                                    text-overflow: ellipsis;
                                    overflow: hidden;
                                    display: block;
                                    white-space: nowrap;
                                  "
                                  >{{
                                    payment?.orderId?.serverId?.employeeFirstName
                                  }}
                                  {{
                                    payment?.orderId?.serverId?.employeeLastName
                                  }}</span
                                >
                              </td>
                              <ng-container *ngIf="filterForColumns[0].checked">
                                <td class="">
                                  <span
                                    *ngIf="
                                      payment.orderId.revenueCenterId !== null
                                    "
                                    >{{
                                      payment.orderId.revenueCenterId
                                        .revenueCenterName | translate | async
                                    }}</span
                                  >
                                </td>
                              </ng-container>
                              <td
                                class=""
                                [ngClass]="{
                                  redLettersRefund:
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionStatus == 2 ||
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionStatus == 4
                                }"
                              >
                                <span
                                  class="card-type"
                                  *ngIf="
                                    payment.transactionIds &&
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionTypeId != 16 &&
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionTypeId != 17 &&
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionTypeId != 18 &&
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionTypeId != 19 &&
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionTypeId != 21 &&
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionTypeId != 22 &&
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionTypeId != 23 &&
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionTypeId != 24 &&
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionTypeId != 28 &&
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionTypeId != 30
                                  "
                                >
                                  <ng-container
                                    [ngSwitch]="
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1 - i
                                      ].transactionTypeId
                                    "
                                    class=""
                                  >
                                    <span *ngSwitchCase="1">{{ "Cash" | translate | async }}</span>
                                    <span *ngSwitchCase="2">{{ "Cheque Payment" | translate | async }} </span>
                                    <span *ngSwitchCase="3">BruinCard</span>
                                    <span *ngSwitchCase="4"
                                      >Givex
                                      <span
                                        *ngIf="
                                          payment.transactionIds[
                                            payment.transactionIds.length - 1 - i
                                          ].extraFields.givexNumber
                                        "
                                        >|
                                        {{
                                          payment.transactionIds[
                                            payment.transactionIds.length - 1 - i
                                          ].extraFields.givexNumber
                                        }}</span
                                      >
                                    </span>
                                    <span *ngSwitchCase="5">UCLA Blood</span>
                                    <span *ngSwitchCase="6">UCLA Career</span>
                                    <span *ngSwitchCase="7">UCLA Dorm</span>
                                    <span *ngSwitchCase="8">UCLA Emp</span>
                                    <span *ngSwitchCase="9">UCLA Meal</span>
                                    <span *ngSwitchCase="10">UCLA Parent</span>
                                    <span *ngSwitchCase="11">UCLA Events</span>
                                    <span *ngSwitchCase="12">GC Promotion</span>
                                    <span *ngSwitchCase="13">GrubHub</span>
                                    <!-- <span *ngSwitchCase="14">Postmates</span> -->
                                    <span *ngSwitchCase="14">Uber Eats</span>
                                    <span *ngSwitchCase="15">Account</span>
                                    <span *ngSwitchCase="16">CardConnect</span>
                                    <span *ngSwitchCase="17">Datacap</span>
                                    <span *ngSwitchCase="18">CreditCall</span>
                                    <span *ngSwitchCase="19">Uno</span>
                                    <span *ngSwitchCase="20">Square</span>
                                    <span *ngSwitchCase="26">Doordash</span>
                                    <span *ngSwitchCase="27">Blizzful</span>
                                    <span *ngSwitchCase="29">Clover</span>
                                    <span *ngSwitchCase="31">eCard</span>
                                    <span *ngSwitchCase="32">Online Order</span>
                                    <span *ngSwitchCase="33">Voucherify</span>
                                    <!-- <span *ngSwitchCase="34">Ubereats</span> -->
                                    <span *ngSwitchCase="35">External CC</span>
                                    <span *ngSwitchCase="36">Otter {{ getSource(payment.orderId.onlineOrderType) }}</span>
                                    <span *ngSwitchCase="37">TotalPay</span>
                                    <span *ngSwitchCase="38">Adyen</span>
                                    <span *ngSwitchDefault>{{ "None" | translate | async }}</span>
                                  </ng-container>
                                </span>
                                <span
                                  class="card-type"
                                  *ngIf="
                                    (payment.transactionIds &&
                                      (payment.transactionIds[
                                        payment.transactionIds.length - 1 - i
                                      ].transactionTypeId == 16 ||
                                        payment.transactionIds[
                                          payment.transactionIds.length - 1 - i
                                        ].transactionTypeId == 17 ||
                                        payment.transactionIds[
                                          payment.transactionIds.length - 1 - i
                                        ].transactionTypeId == 18 ||
                                        payment.transactionIds[
                                          payment.transactionIds.length - 1 - i
                                        ].transactionTypeId == 19)) ||
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionTypeId == 21 ||
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionTypeId == 22 ||
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionTypeId == 23 ||
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionTypeId == 24 ||
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionTypeId == 28 ||
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionTypeId == 30
                                  "
                                >
                                  <img
                                    *ngIf="
                                      (payment.transactionIds[
                                        payment.transactionIds.length - 1 - i
                                      ].extraFields.cardType | lowercase) ==
                                      'mastercard'
                                    "
                                    src="../../../assets/images/master.png"
                                  />
                                  <img
                                    *ngIf="
                                      (payment.transactionIds[
                                        payment.transactionIds.length - 1 - i
                                      ].extraFields.cardType | lowercase) ==
                                      'amex'
                                    "
                                    src="../../../assets/images/amex.png"
                                  />
                                  <img
                                    *ngIf="
                                      (payment.transactionIds[
                                        payment.transactionIds.length - 1 - i
                                      ].extraFields.cardType | lowercase) ==
                                      'disc'
                                    "
                                    src="../../../../../../assets/images/discover.png"
                                  />
                                  <img
                                    *ngIf="
                                      (payment.transactionIds[
                                        payment.transactionIds.length - 1 - i
                                      ].extraFields.cardType | lowercase) ==
                                      'discover'
                                    "
                                    src="../../../../../../assets/images/discover.png"
                                  />
                                  <img
                                    *ngIf="
                                      (payment.transactionIds[
                                        payment.transactionIds.length - 1 - i
                                      ].extraFields.cardType | lowercase) ==
                                      'visa'
                                    "
                                    src="../../../assets/images/visa.png"
                                  />
                                  <span
                                    class="ml-2"
                                    *ngIf="
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1 - i
                                      ].extraFields.cardType != 'UnknownCardType'
                                    "
                                    >|
                                    {{
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1 - i
                                      ].extraFields.maskedPAN | slice : -4
                                    }}</span
                                  >
                                  <img
                                    *ngIf="
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1 - i
                                      ].transactionTypeId == 30
                                    "
                                    src="../../../assets/images/poynt.svg"
                                  />
                                </span>
                                <span *ngIf="!payment.transactionIds"
                                  >{{ "No transaction" | translate | async }}</span
                                >
                              </td>
                              <ng-container *ngIf="filterForColumns[2].checked">
                                <!-- [ngSwitch]="payment.transactionIds[0].transactionStatus"-->
                                <td
                                  [ngSwitch]="payment.orderId.orderSellStatus"
                                  [ngClass]="{
                                    redLettersRefund:
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1 - i
                                      ].transactionStatus == 2 ||
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1 - i
                                      ].transactionStatus == 4
                                  }"
                                  style="
                                    text-align: center;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    overflow: hidden;
                                  "
                                >
                                  <button
                                    accessControl
                                    module="SalesTransaction"
                                    access="3"
                                    class="btn btn-sm status-badge ordering-status-color"
                                    *ngSwitchCase="1"
                                  >
                                    {{ "Ordering" | translate | async }}
                                  </button>
                                  <button
                                    accessControl
                                    module="SalesTransaction"
                                    access="3"
                                    class="btn btn-sm status-badge payment-progress-status-color"
                                    *ngSwitchCase="2"
                                  >
                                    {{ "Payment in progress" | translate | async }}
                                  </button>
                                  <button
                                    accessControl
                                    module="SalesTransaction"
                                    access="3"
                                    class="btn btn-sm status-badge paid-status-color"
                                    *ngSwitchCase="3"
                                  >
                                    {{ "Paid" | translate | async }}
                                  </button>
                                  <button
                                    accessControl
                                    module="SalesTransaction"
                                    access="3"
                                    class="btn btn-sm status-badge completed-status-color"
                                    *ngSwitchCase="4"
                                  >
                                    {{ "Completed" | translate | async }}
                                  </button>
                                  <button
                                    accessControl
                                    module="SalesTransaction"
                                    access="3"
                                    class="btn-sm status-badge refunded-status-color"
                                    *ngSwitchCase="5"
                                  >
                                    {{ "Partially Refunded" | translate | async }}
                                  </button>
                                  <button
                                    accessControl
                                    module="SalesTransaction"
                                    access="3"
                                    class="btn-sm status-badge refunded-status-color"
                                    *ngSwitchCase="6"
                                  >
                                    {{ "Refunded" | translate | async }}
                                  </button>
                                  <button
                                    accessControl
                                    module="SalesTransaction"
                                    access="3"
                                    class="btn-sm status-badge btn-danger"
                                    *ngSwitchCase="7"
                                  >
                                    {{ "Cancelled" | translate | async }}
                                  </button>
                                  <button
                                    class="btn-sm status-badge btn-default"
                                    *ngSwitchDefault
                                  >
                                    {{ "None" | translate | async }}
                                  </button>
                                </td>
                              </ng-container>
                              <td
                                [ngSwitch]="
                                  payment.transactionIds &&
                                  payment.transactionIds[
                                    payment.transactionIds.length - 1 - i
                                  ].transactionStatus
                                "
                                class=""
                              >
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge Approved-theme btn-success"
                                  *ngSwitchCase="1"
                                >
                                  {{ "Approved" | translate | async }}
                                </button>
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge refunded-status-color"
                                  *ngSwitchCase="2"
                                >
                                  {{ "Partially Refunded" | translate | async }}
                                </button>
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge refunded-status-color text-white"
                                  *ngSwitchCase="3"
                                >
                                  {{ "Refunded" | translate | async }}
                                </button>
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge refunded-status-color text-white"
                                  *ngSwitchCase="4"
                                >
                                  {{ "Refund" | translate | async }}
                                </button>
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge refunded-status-color text-white"
                                  *ngSwitchCase="5"
                                >
                                  {{ "Deposited" | translate | async }}
                                </button>
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge voided-status-color text-white"
                                  *ngSwitchCase="6"
                                >
                                  {{ "Voided" | translate | async }}
                                </button>
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge voided-status-color text-white"
                                  *ngSwitchCase="7"
                                >
                                  {{ "Void" | translate | async }}
                                </button>
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge btn-default"
                                  *ngSwitchDefault
                                >
                                  {{ "None" | translate | async }}
                                </button>
                              </td>
                              <ng-container *ngIf="filterForColumns[1].checked">
                                <td
                                  style="text-align: center; font-weight: bold"
                                ></td>
                              </ng-container>
                              <td
                                style="text-align: center; font-weight: bold"
                                [ngClass]="{
                                  redLettersRefund:
                                    payment.transactionIds[
                                      payment.transactionIds.length - 1 - i
                                    ].transactionStatus == 2
                                }"
                              >
                                <span
                                  *ngIf="
                                    i == 0 && payment.transactionIds.length == 1
                                  "
                                  class="text-bold"
                                  >{{
                                    floatnumber(
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1 - i
                                      ].transactionAmount
                                    ) | currency : currency : "symbol" : "1.2-2"
                                  }}
                                </span>
                                <span
                                  *ngIf="
                                    i > 0 || payment.transactionIds.length > 1
                                  "
                                  class="text-bold"
                                  >{{
                                    floatnumber(
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1 - i
                                      ].transactionAmount
                                    ) | currency : currency : "symbol" : "1.2-2"
                                  }}
                                </span>
                              </td>
                            </tr>
                          </ng-container>
                          <tr
                            class="borderBottomTable"
                            *ngIf="payment.transactionIds.length > 1"
                          >
                            <td (click)="toggleTable(x)">
                              <div></div>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <ng-container *ngIf="filterForColumns[0].checked">
                              <td></td>
                            </ng-container>
                            <td></td>
                            <td></td>
                            <td></td>
                            <ng-container *ngIf="filterForColumns[2].checked">
                              <td></td>
                            </ng-container>
                            <ng-container *ngIf="filterForColumns[1].checked">
                              <td
                                style="text-align: center; font-weight: bold"
                              ></td>
                            </ng-container>
                            <td class="text-bold">{{ "TOTAL" | translate | async }}</td>
                            <td style="font-weight: bold" class="text-center">
                              <span class="text-bold">
                                {{
                                  sumarrays(payment.transactionIds)
                                    | currency : currency : "symbol" : "1.2-2"
                                }}
                              </span>
                            </td>
                          </tr>
                        </ng-container>
                        <ng-container
                          *ngIf="
                            !payment.toggle && payment.transactionIds.length > 1
                          "
                        >
                          <tr
                            class="borderBottomTable"
                            (click)="seePaymentReceipt(content, payment, x)"
                          >
                            <td class="p-0">
                              <div
                                (click)="toggleTable(x)"
                                class="position-relative"
                              >
                                <div class="position-absolute" style="left: 5px">
                                  <span
                                    *ngIf="payment.transactionIds.length > 1"
                                    class="dropdown-icon"
                                  >
                                    <i class="mdi mdi-menu-down"></i>
                                  </span>
                                </div>
                                <div>
                                  <span
                                    *ngIf="payment.orderId"
                                    [ngClass]="{
                                      rightSpan: payment.transactionIds.length > 1
                                    }"
                                    >{{ payment.orderId.orderNumber }}</span
                                  >
                                  <span *ngIf="!payment.orderId">---</span>
                                </div>
                              </div>
                            </td>
                            <td class="">
                              <span *ngIf="payment.transactionIds">
                                {{ convertDate(payment.createdAt) | translate | async }}
                              </span>
                              <span *ngIf="!payment.transactionIds">
                                {{ convertDate(payment.createdAt) | translate | async }}
                              </span>
                            </td>
                            <td class="">
                              <span *ngIf="payment.transactionIds">
                                {{ convertTime(payment.createdAt) | translate | async }}
                              </span>
                              <span *ngIf="!payment.transactionIds">
                                {{ convertTime(payment.createdAt) | translate | async }}
                              </span>
                            </td>
                            <td class="">
                              <span *ngIf="payment.transactionIds">
                                {{
                                  payment.transactionIds[
                                    payment.transactionIds.length - 1
                                  ].transactionNumber
                                }}
                              </span>
                              <span *ngIf="!payment.transactionIds"></span>
                            </td>
                            <td class="">{{ payment.payId }}</td>
                            <td class="">
                              <span *ngIf="payment.orderId.serverId !== null"
                                >{{
                                  payment?.orderId?.serverId?.employeeFirstName
                                }}
                                {{
                                  payment?.orderId?.serverId?.employeeLastName
                                }}</span
                              >
                            </td>
                            <ng-container *ngIf="filterForColumns[0].checked">
                              <td class="">
                                <span
                                  *ngIf="payment.orderId.revenueCenterId !== null"
                                >
                                  {{
                                    payment.orderId.revenueCenterId
                                      .revenueCenterName | translate | async
                                  }}
                                </span>
                              </td>
                            </ng-container>
                            <td class="newEllipsis">
                              <ng-container>
                                <span class="card-type">
                                  <ng-container
                                    *ngIf="
                                      payment.transactionIds &&
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1
                                      ].transactionTypeId != 16 &&
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1
                                      ].transactionTypeId != 17 &&
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1
                                      ].transactionTypeId != 18 &&
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1
                                      ].transactionTypeId != 19 &&
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1
                                      ].transactionTypeId != 21 &&
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1
                                      ].transactionTypeId != 22 &&
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1
                                      ].transactionTypeId != 23 &&
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1
                                      ].transactionTypeId != 24 &&
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1
                                      ].transactionTypeId != 28 &&
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1
                                      ].transactionTypeId != 30
                                    "
                                  >
                                    <span>
                                      <ng-container
                                        [ngSwitch]="
                                          payment.transactionIds[
                                            payment.transactionIds.length - 1
                                          ].transactionTypeId
                                        "
                                        class=""
                                      >
                                        <span *ngSwitchCase="1">{{ "Cash" | translate | async }}</span>
                                        <span *ngSwitchCase="2"
                                          >{{ "Cheque Payment" | translate | async }}</span
                                        >
                                        <span *ngSwitchCase="3">BruinCard</span>
                                        <span *ngSwitchCase="4"
                                          >{{ "Givex" | translate | async }}
                                          <span
                                            *ngIf="
                                              payment.transactionIds[
                                                payment.transactionIds.length - 1
                                              ].extraFields.givexNumber
                                            "
                                            >|
                                            {{
                                              payment.transactionIds[
                                                payment.transactionIds.length - 1
                                              ].extraFields.givexNumber
                                            }}</span
                                          >
                                        </span>
                                        <span *ngSwitchCase="5">UCLA Blood</span>
                                        <span *ngSwitchCase="6">UCLA Career</span>
                                        <span *ngSwitchCase="7">UCLA Dorm</span>
                                        <span *ngSwitchCase="8">UCLA Emp</span>
                                        <span *ngSwitchCase="9">UCLA Meal</span>
                                        <span *ngSwitchCase="10"
                                          >UCLA Parent</span
                                        >
                                        <span *ngSwitchCase="11"
                                          >UCLA Events</span
                                        >
                                        <span *ngSwitchCase="12"
                                          >GC Promotion</span
                                        >
                                        <span *ngSwitchCase="13">GrubHub</span>
                                        <!-- <span *ngSwitchCase="14">Postmates</span> -->
                                        <span *ngSwitchCase="14">Uber Eats</span>
                                        <span *ngSwitchCase="15">Account</span>
                                        <span *ngSwitchCase="16"
                                          >CardConnect</span
                                        >
                                        <span *ngSwitchCase="17">Datacap</span>
                                        <span *ngSwitchCase="18">CreditCall</span>
                                        <span *ngSwitchCase="19">Uno</span>
                                        <span *ngSwitchCase="20">Square</span>
                                        <span *ngSwitchCase="26">Doordash</span>
                                        <span *ngSwitchCase="27">Blizzful</span>
                                        <span *ngSwitchCase="29">Clover</span>
                                        <span *ngSwitchCase="31">eCard</span>
                                        <span *ngSwitchCase="32">Online Order</span>
                                        <span *ngSwitchCase="33">Voucherify</span>
                                        <!-- <span *ngSwitchCase="34">Ubereats</span> -->
                                        <span *ngSwitchCase="35">External CC</span>
                                        <span *ngSwitchCase="36">Otter {{ getSource(payment.orderId.onlineOrderType) }}</span>
                                        <span *ngSwitchCase="37">TotalPay</span>
                                        <span *ngSwitchCase="38">Adyen</span>
                                        <span *ngSwitchDefault>{{ "None" | translate | async }}</span>
                                      </ng-container>
                                    </span>
                                  </ng-container>
                                  <ng-container
                                    *ngIf="
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1
                                      ].transactionTypeId == 16 ||
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1
                                      ].transactionTypeId == 17 ||
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1
                                      ].transactionTypeId == 18 ||
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1
                                      ].transactionTypeId == 19 ||
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1
                                      ].transactionTypeId == 21 ||
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1
                                      ].transactionTypeId == 22 ||
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1
                                      ].transactionTypeId == 23 ||
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1
                                      ].transactionTypeId == 24 ||
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1
                                      ].transactionTypeId == 28 ||
                                      payment.transactionIds[
                                        payment.transactionIds.length - 1
                                      ].transactionTypeId == 30
                                    "
                                  >
                                    <img
                                      *ngIf="
                                        (payment.transactionIds[
                                          payment.transactionIds.length - 1
                                        ].extraFields.cardType | lowercase) ==
                                        'mastercard'
                                      "
                                      src="../../../assets/images/master.png"
                                    />
                                    <img
                                      *ngIf="
                                        (payment.transactionIds[
                                          payment.transactionIds.length - 1
                                        ].extraFields.cardType | lowercase) ==
                                        'amex'
                                      "
                                      src="../../../assets/images/amex.png"
                                    />
                                    <img
                                      *ngIf="
                                        (payment.transactionIds[
                                          payment.transactionIds.length - 1
                                        ].extraFields.cardType | lowercase) ==
                                        'disc'
                                      "
                                      src="../../../../../../assets/images/discover.png"
                                    />
                                    <img
                                      *ngIf="
                                        (payment.transactionIds[
                                          payment.transactionIds.length - 1
                                        ].extraFields.cardType | lowercase) ==
                                        'discover'
                                      "
                                      src="../../../../../../assets/images/discover.png"
                                    />
                                    <img
                                      *ngIf="
                                        (payment.transactionIds[
                                          payment.transactionIds.length - 1
                                        ].extraFields.cardType | lowercase) ==
                                        'visa'
                                      "
                                      src="../../../assets/images/visa.png"
                                    />
                                    <span
                                      class="ml-2"
                                      *ngIf="
                                        payment.transactionIds[
                                          payment.transactionIds.length - 1
                                        ].extraFields.cardType !=
                                        'UnknownCardType'
                                      "
                                      >|
                                      {{
                                        payment.transactionIds[
                                          payment.transactionIds.length - 1
                                        ].extraFields.maskedPAN | slice : -4
                                      }}</span
                                    >
                                    <img
                                      *ngIf="
                                        payment.transactionIds[
                                          payment.transactionIds.length - 1
                                        ].transactionTypeId == 30
                                      "
                                      src="../../../assets/images/poynt.svg"
                                    />
                                  </ng-container>
                                </span>
                              </ng-container>
                            </td>
                            <ng-container *ngIf="filterForColumns[2].checked">
                              <td
                                [ngSwitch]="payment.orderId.orderSellStatus"
                                style="
                                  text-align: center;
                                  text-overflow: ellipsis;
                                  white-space: nowrap;
                                  overflow: hidden;
                                "
                              >
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge ordering-status-color"
                                  *ngSwitchCase="1"
                                >
                                  {{ "Ordering" | translate | async }}
                                </button>
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge payment-progress-status-color"
                                  *ngSwitchCase="2"
                                >
                                  {{ "Payment in progress" | translate | async }}
                                </button>
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge paid-status-color"
                                  *ngSwitchCase="3"
                                >
                                  {{ "Paid" | translate | async }}
                                </button>
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge completed-status-color"
                                  *ngSwitchCase="4"
                                >
                                  {{ "Completed" | translate | async }}
                                </button>
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge refunded-status-color"
                                  *ngSwitchCase="5"
                                >
                                  {{ "Partially Refunded" | translate | async }}
                                </button>
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge refunded-status-color"
                                  *ngSwitchCase="6"
                                >
                                  {{ "Refunded" | translate | async }}
                                </button>
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge btn-danger"
                                  *ngSwitchCase="7"
                                >
                                  {{ "Cancelled" | translate | async }}
                                </button>
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge btn-default"
                                  *ngSwitchDefault
                                >
                                  {{ "None" | translate | async }}
                                </button>
                              </td>
                            </ng-container>
                            <td
                              [ngSwitch]="
                                payment.transactionIds &&
                                payment.transactionIds[
                                  payment.transactionIds.length - 1
                                ].transactionStatus
                              "
                              class=""
                            >
                              <button
                                accessControl
                                module="SalesTransaction"
                                access="3"
                                class="btn-sm status-badge Approved-theme btn-success"
                                *ngSwitchCase="1"
                              >
                                {{ "Approved" | translate | async }}
                              </button>
                              <button
                                accessControl
                                module="SalesTransaction"
                                access="3"
                                class="btn-sm status-badge refunded-status-color text-white"
                                *ngSwitchCase="2"
                              >
                                {{ "Partial Refund" | translate | async }}
                              </button>
                              <button
                                accessControl
                                module="SalesTransaction"
                                access="3"
                                class="btn-sm status-badge refunded-status-color text-white"
                                *ngSwitchCase="3"
                              >
                                {{ "Refunded" | translate | async }}
                              </button>
                              <button
                                accessControl
                                module="SalesTransaction"
                                access="3"
                                class="btn-sm status-badge payment-progress-status-color"
                                *ngSwitchCase="4"
                              >
                                {{ "Refund" | translate | async }}
                              </button>
                              <button
                                accessControl
                                module="SalesTransaction"
                                access="3"
                                class="btn-sm status-badge btn-default"
                                *ngSwitchCase="5"
                              >
                                {{ "Deposited" | translate | async }}
                              </button>
                              <button
                                accessControl
                                module="SalesTransaction"
                                access="3"
                                class="btn-sm status-badge voided-status-color text-white"
                                *ngSwitchCase="6"
                              >
                                {{ "Voided" | translate | async }}
                              </button>
                              <button
                                accessControl
                                module="SalesTransaction"
                                access="3"
                                class="btn-sm status-badge voided-status-color text-white"
                                *ngSwitchCase="7"
                              >
                                {{ "Void" | translate | async }}
                              </button>
                              <button
                                accessControl
                                module="SalesTransaction"
                                access="3"
                                class="btn-sm status-badge btn-default"
                                *ngSwitchDefault
                              >
                                {{ "None" | translate | async }}
                              </button>
                            </td>
                            <ng-container *ngIf="filterForColumns[1].checked">
                              <td style="text-align: center; font-weight: bold">
                                {{
                                  payment.orderId.discountAmount
                                    | currency : currency : "symbol" : "1.2-2"
                                }}
                              </td>
                            </ng-container>
                            <td style="text-align: center; font-weight: bold">
                              <span class="text-bold">
                                {{
                                  payment?.transactionIds.length > 0 && payment.transactionIds[
                                    payment.transactionIds.length - 1
                                  ].transactionStatus === 4
                                    ? (payment.paymentAmount | currency : currency : 'symbol' : '1.2-2')
                                    : sumarrays(payment.transactionIds)
                                      | currency : currency : "symbol" : "1.2-2"
                                }}
                              </span>
                            </td>
                          </tr>
                        </ng-container>
                        <ng-container
                          *ngIf="
                            !payment.toggle && payment.transactionIds.length == 1
                          "
                        >
                          <tr
                            class="borderBottomTable"
                            (click)="seePaymentReceipt(content, payment, x)"
                          >
                            <td>
                              <div>
                                <span *ngIf="payment.orderId">{{
                                  payment.orderId.orderNumber
                                }}</span>
                                <span *ngIf="!payment.orderId">---</span>
                              </div>
                            </td>
                            <td class="">
                              <span *ngIf="payment.transactionIds">
                                {{ convertDate(payment.createdAt) | translate | async }}
                              </span>
                              <span *ngIf="!payment.transactionIds">
                                {{ convertDate(payment.createdAt) | translate | async }}
                              </span>
                            </td>
                            <td class="">
                              <span *ngIf="payment.transactionIds">
                                {{ convertTime(payment.createdAt) | translate | async }}
                              </span>
                              <span *ngIf="!payment.transactionIds">
                                {{ convertTime(payment.createdAt) | translate | async }}
                              </span>
                            </td>
                            <td class="">
                              <span *ngIf="payment.transactionIds">{{
                                payment.transactionIds[0].transactionNumber
                              }}</span>
                              <span *ngIf="!payment.transactionIds"></span>
                            </td>
                            <td class="">{{ payment.payId }}</td>
                            <td class="">
                              <span *ngIf="payment.orderId.serverId !== null">
                                {{
                                  payment?.orderId?.serverId?.employeeFirstName
                                }}
                                {{ payment?.orderId?.serverId?.employeeLastName }}
                              </span>
                            </td>
                            <ng-container *ngIf="filterForColumns[0].checked">
                              <td class="">
                                <span
                                  *ngIf="payment.orderId.revenueCenterId !== null"
                                >
                                  {{
                                    payment.orderId.revenueCenterId
                                      .revenueCenterName | translate | async
                                  }}
                                </span>
                              </td>
                            </ng-container>
                            <td class="">
                              <ng-container>
                                <ng-container
                                  *ngIf="
                                    payment.transactionIds[0].transactionTypeId !=
                                      16 &&
                                    payment.transactionIds[0].transactionTypeId !=
                                      17 &&
                                    payment.transactionIds[0].transactionTypeId !=
                                      18 &&
                                    payment.transactionIds[0].transactionTypeId !=
                                      19 &&
                                    payment.transactionIds[0].transactionTypeId !=
                                      21 &&
                                    payment.transactionIds[0].transactionTypeId !=
                                      22 &&
                                    payment.transactionIds[0].transactionTypeId !=
                                      23 &&
                                    payment.transactionIds[0].transactionTypeId !=
                                      24 &&
                                    payment.transactionIds[0].transactionTypeId !=
                                      28 &&
                                    payment.transactionIds[0].transactionTypeId !=
                                      30
                                  "
                                >
                                  <span class="card-type">
                                    <ng-container
                                      [ngSwitch]="
                                        payment.transactionIds[0]
                                          .transactionTypeId
                                      "
                                      class=""
                                    >
                                      <span *ngSwitchCase="1">{{ "Cash" | translate | async }}</span>
                                      <span *ngSwitchCase="2"
                                        >Cheque Payment</span
                                      >
                                      <span *ngSwitchCase="3">BruinCard</span>
                                      <span *ngSwitchCase="4"
                                        >Givex
                                        <span
                                          *ngIf="
                                            payment.transactionIds[0].extraFields
                                              .givexNumber
                                          "
                                          >|
                                          {{
                                            payment.transactionIds[0].extraFields
                                              .givexNumber
                                          }}</span
                                        >
                                      </span>
                                      <span *ngSwitchCase="5">UCLA Blood</span>
                                      <span *ngSwitchCase="6">UCLA Career</span>
                                      <span *ngSwitchCase="7">UCLA Dorm</span>
                                      <span *ngSwitchCase="8">UCLA Emp</span>
                                      <span *ngSwitchCase="9">UCLA Meal</span>
                                      <span *ngSwitchCase="10">UCLA Parent</span>
                                      <span *ngSwitchCase="11">UCLA Events</span>
                                      <span *ngSwitchCase="12">GC Promotion</span>
                                      <span *ngSwitchCase="13">GrubHub</span>
                                      <!-- <span *ngSwitchCase="14">Postmates</span> -->
                                      <span *ngSwitchCase="14">Uber Eats</span>
                                      <span *ngSwitchCase="15">Account</span>
                                      <span *ngSwitchCase="16">CardConnect</span>
                                      <span *ngSwitchCase="17">Datacap</span>
                                      <span *ngSwitchCase="18">CreditCall</span>
                                      <span *ngSwitchCase="19">Uno</span>
                                      <span *ngSwitchCase="20">Square</span>
                                      <span *ngSwitchCase="26">Doordash</span>
                                      <span *ngSwitchCase="27">Blizzful</span>
                                      <span *ngSwitchCase="29">Clover</span>
                                      <span *ngSwitchCase="31">eCard</span>
                                      <span *ngSwitchCase="32">Online Order</span>
                                      <span *ngSwitchCase="33">Voucherify</span>
                                      <!-- <span *ngSwitchCase="34">Ubereats</span> -->
                                      <span *ngSwitchCase="35">External CC</span>
                                      <span *ngSwitchCase="36">Otter {{ getSource(payment.orderId.onlineOrderType) }}</span>
                                      <span *ngSwitchCase="37">TotalPay</span>
                                      <span *ngSwitchCase="38">Adyen</span>
                                      <span *ngSwitchDefault>None</span>
                                    </ng-container>
                                  </span>
                                </ng-container>
                                <span
                                  class="card-type"
                                  *ngIf="
                                    (payment.transactionIds &&
                                      (payment.transactionIds[0]
                                        .transactionTypeId == 16 ||
                                        payment.transactionIds[0]
                                          .transactionTypeId == 17 ||
                                        payment.transactionIds[0]
                                          .transactionTypeId == 18 ||
                                        payment.transactionIds[0]
                                          .transactionTypeId == 19)) ||
                                    payment.transactionIds[0].transactionTypeId ==
                                      21 ||
                                    payment.transactionIds[0].transactionTypeId ==
                                      22 ||
                                    payment.transactionIds[0].transactionTypeId ==
                                      23 ||
                                    payment.transactionIds[0].transactionTypeId ==
                                      24 ||
                                    payment.transactionIds[0].transactionTypeId ==
                                      28 ||
                                    payment.transactionIds[0].transactionTypeId ==
                                      30
                                  "
                                >
                                  <img
                                    *ngIf="
                                      (payment.transactionIds[0].extraFields
                                        .cardType | lowercase) == 'mastercard'
                                    "
                                    src="../../../assets/images/master.png"
                                  />
                                  <img
                                    *ngIf="
                                      (payment.transactionIds[0].extraFields
                                        .cardType | lowercase) == 'amex'
                                    "
                                    src="../../../assets/images/amex.png"
                                  />
                                  <img
                                    *ngIf="
                                      (payment.transactionIds[0].extraFields
                                        .cardType | lowercase) == 'disc'
                                    "
                                    src="../../../../../../assets/images/discover.png"
                                  />
                                  <img
                                    *ngIf="
                                      (payment.transactionIds[0].extraFields
                                        .cardType | lowercase) == 'discover'
                                    "
                                    src="../../../../../../assets/images/discover.png"
                                  />
                                  <img
                                    *ngIf="
                                      (payment.transactionIds[0].extraFields
                                        .cardType | lowercase) == 'visa'
                                    "
                                    src="../../../assets/images/visa.png"
                                  />
                                  <span
                                    class="ml-2"
                                    *ngIf="
                                      payment.transactionIds[0].extraFields
                                        .cardType != 'UnknownCardType'
                                    "
                                    >|
                                    {{
                                      payment.transactionIds[0].extraFields
                                        .maskedPAN | slice : -4
                                    }}</span
                                  >
                                  <img
                                    *ngIf="
                                      payment.transactionIds[0]
                                        .transactionTypeId == 30
                                    "
                                    src="../../../assets/images/poynt.svg"
                                  />
                                </span>
                                <span *ngIf="!payment.transactionIds"
                                  >{{ "No transaction" | translate | async }}</span
                                >
                              </ng-container>
                            </td>
                            <ng-container *ngIf="filterForColumns[2].checked">
                              <td
                                [ngSwitch]="payment.orderId.orderSellStatus"
                                style="
                                  text-align: center;
                                  text-overflow: ellipsis;
                                  white-space: nowrap;
                                  overflow: hidden;
                                "
                              >
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge ordering-status-color"
                                  *ngSwitchCase="1"
                                >
                                  {{ "Ordering" | translate | async }}
                                </button>
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge payment-progress-status-color"
                                  *ngSwitchCase="2"
                                >
                                  {{ "Payment in progress" | translate | async }}
                                </button>
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge paid-status-color"
                                  *ngSwitchCase="3"
                                >
                                  {{ "Paid" | translate | async }}
                                </button>
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge completed-status-color"
                                  *ngSwitchCase="4"
                                >
                                  {{ "Completed" | translate | async }}
                                </button>
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge refunded-status-color"
                                  *ngSwitchCase="5"
                                >
                                  {{ "Partially Refunded" | translate | async }}
                                </button>
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge refunded-status-color"
                                  *ngSwitchCase="6"
                                >
                                  {{ "Refunded" | translate | async }}
                                </button>
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-s Btnm status-badge btn-danger"
                                  *ngSwitchCase="7"
                                >
                                  {{ "Cancelled" | translate | async }}
                                </button>
                                <!-- CHECK orderSellStatus for VOID -->
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge btn-danger"
                                  *ngSwitchCase=""
                                >
                                  {{ "Void" | translate | async }}
                                </button>
                                <button
                                  accessControl
                                  module="SalesTransaction"
                                  access="3"
                                  class="btn-sm status-badge btn-default"
                                  *ngSwitchDefault
                                >
                                  {{ "None" | translate | async }}
                                </button>
                              </td>
                            </ng-container>
                            <td
                              [ngSwitch]="
                                payment.transactionIds &&
                                payment.transactionIds[
                                  payment.transactionIds.length - 1
                                ].transactionStatus
                              "
                              style="text-align: center"
                            >
                              <button
                                accessControl
                                module="SalesTransaction"
                                access="3"
                                class="btn-sm status-badge Approved-theme btn-success"
                                *ngSwitchCase="1"
                              >
                                {{ "Approved" | translate | async }}
                              </button>
                              <button
                                accessControl
                                module="SalesTransaction"
                                access="3"
                                class="btn-sm status-badge refunded-status-color text-white"
                                *ngSwitchCase="2"
                              >
                                {{ "Partial Refund" | translate | async }}
                              </button>
                              <button
                                accessControl
                                module="SalesTransaction"
                                access="3"
                                class="btn-sm status-badge refunded-status-color text-white"
                                *ngSwitchCase="3"
                              >
                                {{ "Refunded" | translate | async }}
                              </button>
                              <button
                                accessControl
                                module="SalesTransaction"
                                access="3"
                                class="btn-sm status-badge payment-progress-status-color"
                                *ngSwitchCase="4"
                              >
                                {{ "Refund" | translate | async }}
                              </button>
                              <button
                                accessControl
                                module="SalesTransaction"
                                access="3"
                                class="btn-sm status-badge btn-default"
                                *ngSwitchCase="5"
                              >
                                {{ "Deposited" | translate | async }}
                              </button>
                              <button
                                accessControl
                                module="SalesTransaction"
                                access="3"
                                class="btn-sm status-badge voided-status-color text-white"
                                *ngSwitchCase="6"
                              >
                                {{ "Voided" | translate | async }}
                              </button>
                              <button
                                accessControl
                                module="SalesTransaction"
                                access="3"
                                class="btn-sm status-badge voided-status-color text-white"
                                *ngSwitchCase="7"
                              >
                                {{ "Void" | translate | async }}
                              </button>
                              <button
                                accessControl
                                module="SalesTransaction"
                                access="3"
                                class="btn-sm status-badge btn-default"
                                *ngSwitchDefault
                              >
                                {{ "None" | translate | async }}
                              </button>
                            </td>
                            <ng-container *ngIf="filterForColumns[1].checked">
                              <td style="text-align: center; font-weight: bold">
                                {{
                                  payment.orderId.discountAmount
                                    | currency : currency : "symbol" : "1.2-2"
                                }}
                              </td>
                            </ng-container>
                            <td style="text-align: center; font-weight: bold">
                              <span class="text-bold">
                                {{
                                  payment.orderId.orderSellStatus === 6
                                    ? (0 | currency: currency: 'symbol':'1.2-2')
                                    : payment?.transactionIds.length > 0 && payment.transactionIds[
                                        payment.transactionIds.length - 1
                                      ]?.transactionStatus === 4 ? (payment.paymentAmount | currency: currency: 'symbol': '1.2-2')
                                    : (sumarrays(payment.transactionIds) | currency: currency: 'symbol':'1.2-2')
                                }}
                              </span>
                            </td>
                          </tr>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </tbody>
                </table>
              </div>
              <div class="pagination-section" style="padding: 1.755em 0px">
                <div class="service-page">
                  <app-paginate-select
                    class="col-xl-4"
                    [(parameter)]="itemsPP"
                    (update)="onLimitSelected($event)"
                  ></app-paginate-select>
                  <div class="fw-500">
                    {{ "Showing" | translate | async }} {{ showItemCountPP + 1 }} {{ "to" | translate | async }}
                    <span>{{ showItemCountPP + metaData$.itemsPerPage }}</span> of
                    <span>{{ metaData$.ordersTotal }}</span> {{ "entries" | translate | async }}
                  </div>
  
                  <div class="d-flex">
                    <pagination-controls
                      class="pagination"
                      (pageChange)="updatePage($event)"
                    >
                    </pagination-controls>
                  </div>
                </div>
              </div>
            </div>
            <div
              *ngIf="transactions$.length == 0"
              class="empty-card d-flex align-items-center justify-content-center"
            >
              <div class="col-lg-4 col-8">
                <div class="d-flex justify-content-center mb-3">
                  <img
                    src="assets\images\transaction-icon.svg"
                    class="card-img-top"
                    style="width: 171px"
                    alt="..."
                  />
                </div>
                <div class="card-body text-center">
                  <h5 class="card-title mb-4 text-xl">
                    {{ "No transactions in This Time Frame" | translate | async }}
                  </h5>
                  <p class="card-text mb-4">
                    {{ "No transactions took place during the time frame you selected. Please select a different range." | translate | async }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- modal section start modal-header -->
  <!-- Standard Modal for transaction details -->
  <ng-template #content let-offcanvas>
    <div class="offcanvas-body">
      <div
        class="bill_details h-100 d-flex flex-column justify-content-between h-100"
      >
        <div class="">
          <app-transaction-detail-header-shared
            [refundModalLoader]="refundModalLoader"
            [voidModalLoader]="voidModalLoader"
            [refundModalSuccess]="refundModalSuccess"
            [voidModalSuccess]="voidModalSuccess"
            [refundModalPageOne]="refundModalPageOne"
            [voidModalPageOne]="voidModalPageOne"
            [refundModalPageTwo]="refundModalPageTwo"
            [voidModalPageTwo]="voidModalPageTwo"
            [receiptModal]="receiptModal"
            [currency]="currency"
            [selectedTotal]="selectedTotal"
            [payment]="paymentReceipt"
            [pRefundModalPageOne]="pRefundModalPageOne"
            [cRefundModalPageOne]="cRefundModalPageOne"
            [cRefundModalPageTwo]="cRefundModalPageTwo"
            (backCRefundPageOne)="backtoCrefundPageOne()"
            [pRefundModalPageTwo]="pRefundModalPageTwo"
            (backtoTransactionDetail)="backtoTransactionDetail()"
            (backtoRefundPageOne)="backtoRefundPageOne()"
            (backtoVoidPageOne)="backtoVoidPageOne()"
            (backPRefundPageOne)="backtoPrefundPageOne()"
            [orderEditModalPageOne]="orderEditModalPageOne"
            [orderEditModalPageTwo]="orderEditModalPageTwo"
            [orderEditModalPageThree]="orderEditModalPageThree"
            (backtoEditorderPageTwo)="backtoEditorderPageTwo()"
            [chageLoader]="chageLoader"
          >
          </app-transaction-detail-header-shared>
          <ng-container *ngIf="!orderEditModalPageOne || !orderEditModalPageTwo">
            <app-transaction-detail-body-shared
              [receiptModal]="receiptModal"
              [paymentReceipt]="paymentReceipt"
            >
            </app-transaction-detail-body-shared>
  
            <ng-container *ngIf="pRefundModalPageOne || cRefundModalPageOne">
              <app-transaction-partialrefund-modal-shared
                [pRefundModalPageOne]="pRefundModalPageOne"
                [pRefundModalPageTwo]="pRefundModalPageOne"
                [totalPartialRefund]="totalPartialRefund"
                [cRefundModalPageOne]="cRefundModalPageOne"
                [totalCustomRefund]="customRefund"
                (customChangeAmount)="changeCRefundAmont($event)"
                (changeAmount)="changeRefundAmont($event)"
                [refundProductList]="refundProductList"
                [currency]="currency"
              >
              </app-transaction-partialrefund-modal-shared>
            </ng-container>
            <ng-container *ngIf="pRefundModalPageTwo || cRefundModalPageTwo">
              <app-transaction-fullrefund-modal-shared
                [refundOptions]="refundOptions"
                [globalAmount]="globalAmount"
                [refundReason]="refundReason"
                [noteReason]="noteReason"
                (changeRefundReason)="changeRefundReason($event)"
                (changeRefundReasonNote)="changeRefundReasonNote($event)"
                [cRefundModalPageTwo]="cRefundModalPageTwo"
                [pRefundModalPageTwo]="pRefundModalPageTwo"
                (changeCRefundReason)="changeCRefundReason($event)"
                (changeCRefundReasonNote)="changeCRefundReasonNote($event)"
              >
              </app-transaction-fullrefund-modal-shared>
            </ng-container>
  
            <div
              class="col-12 text-center"
              [ngClass]="!refundModalLoader ? 'mt-4 mb-2' : 'mt-3'"
              *ngIf="refundModalPageOne || refundModalLoader"
            >
              <h1 class="f-40 fw-600">
                {{ currency }}{{ globalAmount | number : "1.2-2" }}
              </h1>
            </div>
            <div
              class="col-12 text-center"
              [ngClass]="!voidModalLoader ? 'mt-4 mb-2' : 'mt-3'"
              *ngIf="voidModalPageOne || voidModalLoader"
            >
              <h1 class="f-40 fw-600">
                {{ currency }}{{ globalAmount | number : "1.2-2" }}
              </h1>
            </div>
  
            <div
              class="col-12 my-3"
              *ngIf="
                refundModalLoader ||
                refundModalSuccess ||
                voidModalLoader ||
                voidModalSuccess
              "
            >
              <div class="receipt-send-box loader-box mt-0">
                <app-transaction-loader-modal-shared
                  class="text-center"
                  [globalAmount]="
                    partialRefundActive
                      ? totalPartialRefund
                      : customRefundActive
                      ? customRefund1
                      : globalAmount
                  "
                  [currency]="currency"
                  [refundModalLoader]="refundModalLoader"
                  [voidModalLoader]="voidModalLoader"
                  [refundModalSuccess]="refundModalSuccess"
                  [customRefundedS] = "customRefundedS"
                  [voidModalSuccess]="voidModalSuccess"
                >
                </app-transaction-loader-modal-shared>
              </div>
            </div>
  
            <ng-container *ngIf="refundModalPageTwo || voidModalPageTwo">
              <app-transaction-fullrefund-modal-shared
                [refundModalPageTwo]="refundModalPageTwo"
                [voidModalPageTwo]="voidModalPageTwo"
                [refundOptions]="refundOptions"
                [globalAmount]="globalAmount"
                [refundReason]="refundReason"
                [noteReason]="noteReason"
                (changeRefundReason)="changeRefundReason($event)"
                (changeRefundReasonNote)="changeRefundReasonNote($event)"
              >
              </app-transaction-fullrefund-modal-shared>
            </ng-container>
            <ng-container
              *ngIf="
                !receiptModal &&
                !refundModalPageTwo &&
                !voidModalPageTwo &&
                !refundModalSuccess &&
                !voidModalSuccess &&
                !refundModalLoader &&
                !voidModalLoader &&
                !pRefundModalPageTwo &&
                !cRefundModalPageTwo &&
                !orderEditModalPageOne &&
                !orderEditModalPageTwo
              "
            >
              <app-transaction-order-table-shared
                [currency]="currency"
                [pRefundModalPageOne]="pRefundModalPageOne"
                [paymentReceipt]="paymentReceipt"
                [paymentReceiptCopy]="paymentReceiptCopy"
                [refundProductList]="refundProductList"
                (addProductsInListToRefund)="addProductsInListToRefund($event)"
              ></app-transaction-order-table-shared>
            </ng-container>
  
            <ng-container *ngIf="receiptModal">
              <app-transaction-receipt-modal-shared
                [currency]="currency"
                [globalAmount]="globalAmount"
                [globalOrderId]="globalOrderId"
                [ModuleDetails]="ModuleDetails"
                (goToTransactionDetail)="backtoTransactionDetail()"
              >
              </app-transaction-receipt-modal-shared>
            </ng-container>
          </ng-container>
  
          <ng-container *ngIf="orderEditModalPageOne || orderEditModalPageTwo">
            <app-transaction-order-edit-shared
              [timerDisplay]="timerDisplay"
              [timeToVerify]="timeToVerify"
              [buttonApprove]="buttonApprove"
              (otpEmit)="isVerificationOk($event)"
              (nextPage)="nextPage()"
              [orderEditModalPageOne]="orderEditModalPageOne"
              [orderEditModalPageTwo]="orderEditModalPageTwo"
              [currency]="currency"
              [paymentReceipt]="paymentReceipt"
              (selectTransactionEditOrder)="selectTransactionEditOrder($event)"
              [orderEditModalPageThree]="orderEditModalPageThree"
              [employees]="activeEmployees$"
              [userSelected]="userSelected"
              (changeValueSelect)="changeValueSelect($event)"
              [editPayment]="editPayment"
              [tipAmount]="tipAmount"
              (changeAmount)="changeEditTipAmount($event)"
              (changeTipFunction)="changeTipFunction(content)"
              [chageLoader]="chageLoader"
              (resendOtpEditOrder)="resendOtpEditOrder()"
            ></app-transaction-order-edit-shared>
          </ng-container>
        </div>
        <ng-container *ngIf="!orderEditModalPageOne && !orderEditModalPageTwo">
          <ng-container
            *ngIf="
              !refundModalSuccess &&
              !refundModalLoader &&
              !voidModalLoader &&
              !voidModalSuccess
            "
          >
            <app-transaction-detail-footer-shared
              [refundReason]="refundReason"
              [receiptModal]="receiptModal"
              [refundModalPageOne]="refundModalPageOne"
              [voidModalPageOne]="voidModalPageOne"
              [refundModalPageTwo]="refundModalPageTwo"
              [voidModalPageTwo]="voidModalPageTwo"
              [globalAmount]="globalAmount"
              [currency]="currency"
              [promoCodeValue]="promoCodeValue"
              [checkingComponent]="checkingComponent"
              [paymentReceipt]="paymentReceipt"
              [deliveryFee]="deliveryFee"
              [pRefundModalPageOne]="pRefundModalPageOne"
              [pRefundModalPageTwo]="pRefundModalPageTwo"
              [cRefundModalPageTwo]="cRefundModalPageTwo"
              [cRefundModalPageOne]="cRefundModalPageOne"
              [editOrdenSecondStep]="editOrdenSecondStep"
              [refundPartialItems]="refundProductList"
              (sendReceipt)="sendReceipt($event)"
              (fullRefund)="fullRefund($event)"
              (voidOrder)="voidOrder($event)"
              (goToRefundPageTwo)="goToRefundPageTwo()"
              (goToVoidPageTwo)="goToVoidPageTwo()"
              [totalPartialRefund]="totalPartialRefund"
              [totalCustomRefund]="customRefund"
              (fullPaymentRefund)="fullPaymentRefund($event)"
              (voidPayment)="voidPayment($event)"
              (closeOrder)="closeOrder($event, content)"
              [closeOrderLoader]="closeOrderLoader"
              [closeOrderStatus]="closeOrderStatus"
              (partialRefund)="partialRefundPage($event)"
              (customRefund)="customRefundPage($event)"
              (goToPRefundPageTWo)="goToPRefundPageTWo()"
              (goToCRefundPageTWo)="goToCRefundPageTWo()"
              (partialPaymentRefund)="partialPaymentRefund($event)"
              (customPaymentRefund)="customPaymentRefund($event)"
              (editOrder)="editOrder($event)"
              [editOrderLoader]="editOrderLoader"
              [voidOrderLoader]="voidOrderLoader"
            ></app-transaction-detail-footer-shared>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </ng-template>
  